/* =====================================================================
   FreakyFits Theme, theme.js
   Kein Framework, keine Abhängigkeiten.
   ===================================================================== */
(() => {
  'use strict';

  const FF = window.FF || {};
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);
  const reduceMotion = () =>
    FF.motion === 'off' || window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Hilfsfunktionen ---------------------------------------- */
  function formatMoney(cents, format = FF.moneyFormat || '€{{amount_with_comma_separator}}') {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = parseInt(cents, 10) || 0;
    const fmt = (n, decimals, th = '.', dec = ',') => {
      const fixed = (n / 100).toFixed(decimals);
      const [int, frac] = fixed.split('.');
      const withTh = int.replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return frac ? withTh + dec + frac : withTh;
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return fmt(value, 2, ',', '.');
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(value, 2, "'", '.');
        default: return fmt(value, 2, '.', ',');
      }
    });
  }

  const debounce = (fn, wait = 250) => {
    let t;
    return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), wait); };
  };

  function toast(msg) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove('is-visible'), 2800);
  }
  FF.toast = toast;

  /* ---------- Drawer (Menü, Warenkorb, Filter) ----------------------- */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    $$(`[aria-controls="${id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    setTimeout(() => {
      const f = $('button, a, input, select', $('.drawer__panel', d));
      f && f.focus({ preventScroll: true });
    }, 60);
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    $$(`[aria-controls="${d.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (!$('.drawer.is-open') && !$('.search-modal.is-open')) document.body.classList.remove('is-locked');
    lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true });
  }
  FF.openDrawer = openDrawer;

  on(document, 'click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.drawerOpen); return; }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('[data-drawer]')); }
  });
  on(document, 'keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer);
    closeSearch();
    $$('[data-quick].is-open').forEach(closeQuick);
    $$('[data-nav-item].is-open').forEach((i) => i.classList.remove('is-open'));
  });

  /* ---------- Header -------------------------------------------------- */
  function initHeader() {
    const header = $('[data-header]');
    if (!header) return;
    const hide = header.dataset.hideOnScroll === 'true';
    let lastY = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 10);
      const wrap = header.closest('.section-header') || header;
      if (hide) {
        const hidden = y > lastY && y > 300;
        wrap.classList.toggle('is-hidden', hidden);
        document.documentElement.style.setProperty('--sticky-top', hidden ? '0px' : header.offsetHeight + 'px');
      }
      lastY = y;
    };
    on(window, 'scroll', onScroll, { passive: true });
    onScroll();
    const setH = () => document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
    setH();
    on(window, 'resize', debounce(setH, 150));

    // Touch/Tastatur: erster Tipp öffnet das Mega-Menü
    $$('[data-nav-trigger]').forEach((trigger) => {
      const item = trigger.closest('[data-nav-item]');
      on(trigger, 'click', (e) => {
        const isTouch = window.matchMedia('(hover: none)').matches;
        if (isTouch && !item.classList.contains('is-open')) {
          e.preventDefault();
          $$('[data-nav-item].is-open').forEach((i) => i !== item && i.classList.remove('is-open'));
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
      on(item, 'mouseenter', () => trigger.setAttribute('aria-expanded', 'true'));
      on(item, 'mouseleave', () => { trigger.setAttribute('aria-expanded', 'false'); item.classList.remove('is-open'); });
    });
    on(document, 'click', (e) => {
      if (!e.target.closest('[data-nav-item]')) $$('[data-nav-item].is-open').forEach((i) => i.classList.remove('is-open'));
    });
  }

  /* ---------- Ankündigungsleiste ------------------------------------- */
  function initAnnouncement(root = document) {
    $$('[data-announce]', root).forEach((bar) => {
      const slides = $$('.announce__slide', bar);
      if (slides.length < 2 || bar._timer) return;
      let i = 0;
      bar._timer = setInterval(() => {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, parseInt(bar.dataset.interval, 10) || 5000);
    });
  }

  /* ---------- Suche --------------------------------------------------- */
  const searchModal = () => $('[data-search-modal]');
  function openSearch() {
    const m = searchModal();
    if (!m) return;
    m.classList.add('is-open');
    m.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    setTimeout(() => $('[data-predictive-input]', m).focus(), 50);
    try { ffIndex(FF.routes.allProducts || '/collections/all'); } catch (e) { /* Index vorladen für Artikelnummern */ }
  }
  function closeSearch() {
    const m = searchModal();
    if (!m || !m.classList.contains('is-open')) return;
    m.classList.remove('is-open');
    m.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('is-locked');
  }
  on(document, 'click', (e) => {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
    if (e.target.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); }
  });
  /* ---------- Suche nach Artikelnummer --------------------------------- */
  // Shopify findet Artikelnummern nur bei exakter Eingabe. Das Theme sucht zusätzlich im eigenen Produkt-Index,
  // auch Teil-Nummern („GC11959“ findet „GC11959-M“), und springt bei eindeutigem Treffer direkt zum Produkt.
  const looksLikeSku = (q) => /^[a-z0-9][a-z0-9._\-\/]{2,}$/i.test(q.trim()) && /\d/.test(q) && /[a-z]/i.test(q) || /^\d{4,}$/.test(q.trim());
  async function findBySku(q, timeout = 2500) {
    const c = norm(q).replace(/\s+/g, '');
    const run = ffIndex(FF.routes.allProducts || '/collections/all').then((all) => {
      const exact = all.filter((p) => (p.s || []).some((s) => norm(s) === c));
      if (exact.length) return exact;
      return all.filter((p) => (p.s || []).some((s) => norm(s).startsWith(c))).slice(0, 8);
    });
    return Promise.race([run, new Promise((r) => setTimeout(() => r([]), timeout))]);
  }
  function skuBlockHTML(list, q) {
    return `<div class="predictive__sku"><p class="predictive__heading">Artikelnummer „${esc(q)}“</p>${list.slice(0, 4).map((p) => `
      <a class="predictive__product" href="${esc(p.u)}">${p.i ? `<img src="${esc(p.i)}" alt="" width="60" height="75" loading="lazy">` : ''}
        <span><strong>${esc(p.t)}</strong><small>${esc((p.s || []).filter(Boolean).slice(0, 3).join(', '))}</small><span class="price__current">${formatMoney(p.p)}</span></span></a>`).join('')}</div>`;
  }
  // Absenden: eindeutige Artikelnummer -> direkt zum Produkt
  on(document, 'submit', async (e) => {
    const form = e.target.closest('[data-search-form]');
    if (!form || form._skuChecked) return;
    const q = (form.querySelector('[name="q"]') || {}).value || '';
    if (!looksLikeSku(q)) return;
    e.preventDefault();
    const hits = await findBySku(q);
    if (hits.length === 1) { window.location.href = hits[0].u; return; }
    form._skuChecked = true;
    form.submit();
  });
  // Suchseite ohne Treffer: Artikelnummer im Index nachschlagen
  async function initSkuFallback() {
    const box = $('[data-sku-fallback]');
    if (!box) return;
    const q = box.dataset.skuFallback || '';
    if (!looksLikeSku(q)) return;
    const hits = await findBySku(q, 8000);
    if (!hits.length) return;
    if (hits.length === 1) { window.location.replace(hits[0].u); return; }
    box.innerHTML = `<p class="eyebrow" style="margin-bottom:12px">Treffer zur Artikelnummer „${esc(q)}“</p><div class="grid product-grid" style="--cols: 4">${hits.map(renderCardHTML).join('')}</div>`;
    box.hidden = false;
    const empty = box.nextElementSibling; if (empty && empty.classList.contains('empty-state')) empty.hidden = true;
  }

  function initPredictive() {
    const input = $('[data-predictive-input]');
    const results = $('[data-predictive-results]');
    if (!input || !results) return;
    const initial = results.innerHTML;
    let controller;
    on(input, 'input', debounce(async () => {
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = initial; return; }
      controller && controller.abort();
      controller = new AbortController();
      try {
        const url = `${FF.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection,query,page&resources[limit]=8&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag&section_id=predictive-search`;
        const [res, skuHits] = await Promise.all([fetch(url, { signal: controller.signal }), looksLikeSku(q) ? findBySku(q, 1500) : Promise.resolve([])]);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const section = doc.querySelector('.shopify-section') || doc.body;
        results.innerHTML = (skuHits.length ? skuBlockHTML(skuHits, q) : '') + section.innerHTML;
        if (skuHits.length) { const empty = $('.predictive__empty', results); if (empty) empty.remove(); }
      } catch (err) { /* abgebrochen */ }
    }, 220));
  }

  /* ---------- Warenkorb ---------------------------------------------- */
  const cartSectionIds = () => {
    const ids = $$('[data-cart-section]').map((el) => el.dataset.cartSection);
    return Array.from(new Set(ids));
  };

  function renderCartSections(sections) {
    if (!sections) return;
    Object.entries(sections).forEach(([id, html]) => {
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector(`[data-cart-section="${id}"]`);
      const current = document.querySelector(`[data-cart-section="${id}"]`);
      if (!fresh || !current) return;
      if (current.hasAttribute('data-cart-drawer')) {
        // Nur Panel-Inhalt tauschen, damit der Drawer offen bleibt
        const panel = $('.drawer__panel', current);
        const freshPanel = $('.drawer__panel', fresh);
        const scroll = $('.drawer__body', panel) ? $('.drawer__body', panel).scrollTop : 0;
        panel.innerHTML = freshPanel.innerHTML;
        const body = $('.drawer__body', panel);
        if (body) body.scrollTop = scroll;
      } else {
        current.innerHTML = fresh.innerHTML;
      }
    });
    fillEmptyText();
    try { initUpsell(document); } catch (err) { /* egal */ }
    try { initComboCart(document); } catch (err) { /* egal */ }
    syncComboCode();
    const hint = $('[data-combo-hint]');
    if (hint && !hint.classList.contains('is-costume')) { hint._init = false; initComboHint(document); }
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count > 0 ? count : '';
      el.dataset.count = count;
      const btn = el.closest('a, button');
      if (btn) {
        btn.setAttribute('aria-label', `Warenkorb (${count})`);
        btn.classList.remove('is-bumped');
        void btn.offsetWidth;
        btn.classList.add('is-bumped');
      }
    });
  }

  function fillEmptyText() {
    $$('[data-empty-text]').forEach((p) => { p.textContent = FF.strings.empty; });
  }

  async function addToCart(items, sourceEl) {
    const body = { items, sections: cartSectionIds().join(','), sections_url: window.location.pathname };
    const res = await fetch(FF.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || FF.strings.error);

    const cart = await (await fetch(FF.routes.cart + '.js')).json();
    updateCount(cart.item_count);
    renderCartSections(data.sections);

    document.dispatchEvent(new CustomEvent('ff:cart-added', { detail: { source: sourceEl, cart } }));
    toast(FF.strings.added);

    if (FF.cartType === 'drawer' && $('[data-cart-drawer]')) {
      setTimeout(() => openDrawer('CartDrawer'), reduceMotion() ? 0 : 650);
    } else if (FF.cartType === 'page') {
      // bleibt auf der Seite, Toast reicht, Warenkorb über Icon erreichbar
    }
    return cart;
  }
  FF.addToCart = addToCart;

  async function changeLine(key, quantity) {
    const res = await fetch(FF.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity, sections: cartSectionIds().join(','), sections_url: window.location.pathname })
    });
    const data = await res.json();
    if (!res.ok) { toast(data.description || FF.strings.error); return; }
    updateCount(data.item_count);
    renderCartSections(data.sections);
  }

  // Quick-Add auf Karten / Upsells
  on(document, 'click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const id = parseInt(btn.dataset.quickAdd, 10);
    btn.classList.add('is-loading');
    try {
      await addToCart([{ id, quantity: 1 }], btn);
      const q = btn.closest('[data-quick]');
      q && closeQuick(q);
    } catch (err) {
      toast(err.message);
    } finally {
      btn.classList.remove('is-loading');
    }
  });

  function closeQuick(q) {
    q.classList.remove('is-open');
    const t = $('[data-quick-toggle]', q);
    t && t.setAttribute('aria-expanded', 'false');
  }
  on(document, 'click', (e) => {
    const t = e.target.closest('[data-quick-toggle]');
    if (t) {
      e.preventDefault();
      const q = t.closest('[data-quick]');
      const open = !q.classList.contains('is-open');
      $$('[data-quick].is-open').forEach(closeQuick);
      q.classList.toggle('is-open', open);
      t.setAttribute('aria-expanded', open);
      return;
    }
    if (!e.target.closest('[data-quick]')) $$('[data-quick].is-open').forEach(closeQuick);
  });

  // Mengen & Entfernen im Warenkorb
  on(document, 'click', (e) => {
    const item = e.target.closest('.cart-item');
    if (!item) return;
    const line = item.dataset.key;
    const change = e.target.closest('[data-qty-change]');
    if (change) {
      const input = $('[data-qty-input]', item);
      const next = Math.max(0, parseInt(input.value, 10) + parseInt(change.dataset.qtyChange, 10));
      input.value = next;
      if (next === 0) item.classList.add('is-removing');
      changeLine(line, next);
    }
    if (e.target.closest('[data-remove]')) {
      item.classList.add('is-removing');
      changeLine(line, 0);
    }
  });
  on(document, 'change', (e) => {
    if (e.target.matches('.cart-item [data-qty-input]')) {
      const item = e.target.closest('.cart-item');
      changeLine(item.dataset.key, Math.max(0, parseInt(e.target.value, 10) || 0));
    }
    if (e.target.matches('[data-cart-note]')) {
      fetch(FF.routes.cartUpdate + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: e.target.value })
      });
    }
  });

  // Warenkorb-Icon öffnet Drawer
  on(document, 'click', (e) => {
    const c = e.target.closest('[data-cart-open]');
    if (c && FF.cartType === 'drawer' && $('[data-cart-drawer]')) {
      e.preventDefault();
      openDrawer('CartDrawer');
    }
  });

  /* ---------- Produktformular ---------------------------------------- */
  function initProduct(root = document) {
    $$('[data-product]', root).forEach((wrap) => {
      if (wrap._init) return;
      wrap._init = true;
      const jsonEl = $('[data-product-json]', wrap);
      if (!jsonEl) return;
      const product = JSON.parse(jsonEl.textContent);
      const form = $('[data-product-form]', wrap);
      const idInput = $('input[name="id"]', form);
      const atc = $('[data-atc]', wrap);
      const priceWrap = $('[data-price-wrap]', wrap);
      const stock = $('[data-stock]', wrap);
      const sticky = $('[data-sticky-atc]');
      let extra = {};
      try { extra = JSON.parse(($('[data-variant-extra]', wrap) || {}).textContent || '{}'); } catch (e) { extra = {}; }
      const skuWrap = $('[data-sku-wrap]', wrap);
      if (!form || !atc || !idInput) return;

      const selected = () => $$('[data-option-index]', wrap).map((fs) => {
        const c = $('input:checked', fs);
        return c ? c.value : null;
      });

      const findVariant = (opts) =>
        product.variants.find((v) => v.options.every((o, i) => opts[i] === null || o === opts[i]) && opts.every((o) => o !== null));

      function markAvailability() {
        const opts = selected();
        $$('[data-option-index]', wrap).forEach((fs) => {
          const idx = parseInt(fs.dataset.optionIndex, 10);
          $$('input', fs).forEach((input) => {
            const test = opts.slice();
            test[idx] = input.value;
            const exists = product.variants.some((v) =>
              v.available && v.options.every((o, i) => (i === idx ? o === input.value : test[i] === null || o === test[i]))
            );
            input.classList.toggle('is-unavailable', !exists);
          });
        });
      }

      function renderPrice(v) {
        if (!priceWrap) return;
        const sale = v.compare_at_price && v.compare_at_price > v.price;
        let html = `<div class="price price--lg${sale ? ' price--sale' : ''}" data-price><span class="price__current">${formatMoney(v.price)}</span>`;
        if (sale) {
          const pct = Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price);
          html += `<s class="price__compare"><span class="visually-hidden">Statt</span>${formatMoney(v.compare_at_price)}</s><span class="price__save">-${pct}%</span>`;
        }
        const up = extra[v.id] && extra[v.id].up;
        if (up) html += `<span class="price__unit" data-unit-price>Grundpreis: ${up}</span>`;
        html += '</div>';
        const old = $('[data-price]', priceWrap);
        old ? (old.outerHTML = html) : priceWrap.insertAdjacentHTML('afterbegin', html);
        priceWrap.dataset.cents = v.price;
        if (FF._comboPrice) FF._comboPrice();
      }

      function update() {
        const opts = selected();
        $$('[data-option-index]', wrap).forEach((fs, i) => {
          const lbl = $('[data-option-value]', fs);
          if (lbl) lbl.textContent = opts[i] || '';
        });
        markAvailability();
        const v = findVariant(opts);
        const missingFs = $$('[data-option-index]', wrap).find((f) => !$('input:checked', f));
        const setInactive = (on, label) => {
          [atc, sticky && $('[data-sticky-btn]', sticky)].forEach((b) => {
            if (!b) return;
            b.classList.toggle('is-inactive', on);
            if (on) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
          });
          if (sticky && $('[data-sticky-btn]', sticky)) $('[data-sticky-btn]', sticky).textContent = on ? label.replace('Bitte ', '') : (v && !v.available ? FF.strings.soldOut : FF.strings.addToCart);
        };
        if (!v) {
          if (missingFs) {
            const label = `Bitte ${missingFs.dataset.optionName || 'Größe'} wählen`;
            atc.disabled = false;
            atc.querySelector('[data-atc-text]').textContent = label;
            setInactive(true, label);
          } else {
            setInactive(false);
            atc.disabled = true;
            atc.querySelector('[data-atc-text]').textContent = FF.strings.unavailable;
            const sb = sticky && $('[data-sticky-btn]', sticky);
            if (sb) { sb.disabled = true; sb.textContent = FF.strings.unavailable; }
          }
          idInput.value = '';
          return;
        }
        setInactive(false);
        idInput.value = v.id;
        atc.disabled = !v.available;
        atc.querySelector('[data-atc-text]').textContent = v.available ? FF.strings.addToCart : FF.strings.soldOut;
        renderPrice(v);
        if (skuWrap) {
          const sku = (extra[v.id] && extra[v.id].sku) || v.sku || '';
          $('[data-sku]', skuWrap).textContent = sku;
          skuWrap.hidden = !sku;
        }
        if (stock) {
          const qty = wrap.getAttribute(`data-inv-${v.id}`);
          const policy = wrap.getAttribute(`data-inv-policy-${v.id}`);
          stock.className = 'stock';
          if (!v.available) { stock.classList.add('stock--out'); stock.textContent = 'Leider ausverkauft'; }
          else if (qty !== null && parseInt(qty, 10) <= 0 && policy === 'continue') { stock.classList.add('stock--low'); stock.textContent = 'Bestellbar, wird nachgeliefert (längere Lieferzeit)'; }
          else if (qty && parseInt(qty, 10) > 0 && parseInt(qty, 10) <= 5) { stock.classList.add('stock--low'); stock.textContent = `Nur noch ${qty} Stück auf Lager, schnell sein!`; }
          else { stock.textContent = 'Auf Lager & lieferbar'; }
        }
        if (v.featured_media) {
          const slide = $(`[data-media-id="${v.featured_media.id}"]`, wrap);
          slide && goToSlide(wrap, slide);
        }
        if (wrap.dataset.updateUrl === 'true') {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        if (sticky) {
          const sp = $('[data-sticky-price]', sticky);
          if (sp) sp.textContent = formatMoney(v.price);
          const su = $('[data-sticky-unit]', sticky);
          if (su) { const u = extra[v.id] && extra[v.id].up; su.textContent = u ? `Grundpreis: ${u}` : ''; su.hidden = !u; }
          const sb = $('[data-sticky-btn]', sticky);
          if (sb) sb.disabled = !v.available;
        }
      }

      on(wrap, 'change', (e) => { if (e.target.closest('[data-option-index]')) update(); });

      // Menge
      on(wrap, 'click', (e) => {
        const b = e.target.closest('[data-pdp-qty]');
        if (!b) return;
        const input = $('input[name="quantity"]', form);
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.pdpQty, 10));
      });

      const nudgeOptions = () => {
        const fs = $$('[data-option-index]', wrap).find((f) => !$('input:checked', f));
        if (!fs) return;
        fs.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'center' });
        fs.animate && !reduceMotion() && fs.animate(
          [{ transform: 'translateX(0)' }, { transform: 'translateX(-8px)' }, { transform: 'translateX(8px)' }, { transform: 'translateX(0)' }],
          { duration: 360, iterations: 2 }
        );
        toast(FF.strings.chooseSize);
      };

      on(form, 'submit', async (e) => {
        e.preventDefault();
        if (selected().includes(null) || !idInput.value) { nudgeOptions(); return; }
        atc.classList.add('is-loading');
        try {
          await addToCart([{ id: parseInt(idInput.value, 10), quantity: parseInt(($('input[name="quantity"]', form) || {}).value, 10) || 1 }], atc);
        } catch (err) {
          toast(err.message);
        } finally {
          atc.classList.remove('is-loading');
        }
      });

      if (sticky) {
        const sb = $('[data-sticky-btn]', sticky);
        on(sb, 'click', () => {
          if (selected().includes(null)) { nudgeOptions(); return; }
          if (atc.disabled || !idInput.value) return;
          form.requestSubmit ? form.requestSubmit() : atc.click();
        });
        const io = new IntersectionObserver(([entry]) => {
          sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
        io.observe(atc);
      }

      initGallery(wrap);
      update();
    });
  }

  /* ---------- Galerie -------------------------------------------------- */
  function goToSlide(wrap, slide) {
    const main = $('[data-gallery-main]', wrap);
    if (!main || !slide) return;
    main.scrollTo({ left: slide.offsetLeft - main.offsetLeft, behavior: reduceMotion() ? 'auto' : 'smooth' });
  }
  function initGallery(wrap) {
    const main = $('[data-gallery-main]', wrap);
    if (!main) return;
    const slides = $$('[data-media-id]', main);
    const thumbs = $$('[data-thumb]', wrap);
    const counter = $('[data-gallery-counter]', wrap);
    const setCurrent = (i) => {
      thumbs.forEach((t, j) => t.setAttribute('aria-current', i === j));
      if (counter) counter.textContent = `${i + 1} / ${slides.length}`;
    };
    thumbs.forEach((t, i) => on(t, 'click', () => goToSlide(wrap, slides[i])));
    on(main, 'scroll', debounce(() => {
      const i = Math.round(main.scrollLeft / main.clientWidth);
      setCurrent(Math.min(slides.length - 1, Math.max(0, i)));
    }, 60), { passive: true });
    $$('[data-gallery-prev],[data-gallery-next]', wrap).forEach((b) =>
      on(b, 'click', () => {
        const dir = b.hasAttribute('data-gallery-next') ? 1 : -1;
        main.scrollBy({ left: dir * main.clientWidth, behavior: 'smooth' });
      })
    );
    // Zoom per Klick: Bild in voller Größe im Modal
    const zoom = $('[data-zoom-modal]');
    if (zoom) {
      slides.forEach((s) => on(s, 'click', () => {
        const img = $('img', s);
        if (!img) return;
        $('[data-zoom-img]', zoom).src = s.dataset.full || img.currentSrc || img.src;
        $('[data-zoom-img]', zoom).alt = img.alt;
        zoom.showModal();
      }));
    }
    setCurrent(0);
  }

  /* ---------- Link kopieren ------------------------------------------ */
  on(document, 'click', async (e) => {
    const b = e.target.closest('[data-share-copy]');
    if (!b) return;
    const url = b.dataset.shareCopy;
    if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
      try { await navigator.share({ title: document.title, url }); return; } catch (err) { /* abgebrochen */ }
    }
    try { await navigator.clipboard.writeText(url); toast('Link kopiert! 🔗'); } catch (err) { window.prompt('Link kopieren:', url); }
  });

  /* ---------- Modals (Größentabelle usw.) --------------------------- */
  on(document, 'click', (e) => {
    const opener = e.target.closest('[data-modal-open]');
    if (opener) {
      const m = document.getElementById(opener.dataset.modalOpen);
      if (m && m.showModal) { e.preventDefault(); m.showModal(); }
    }
    const closer = e.target.closest('[data-modal-close]');
    if (closer) closer.closest('dialog').close();
    if (e.target.tagName === 'DIALOG') e.target.close(); // Klick auf Hintergrund
  });

  /* ---------- Lieferzeit ------------------------------------------------ */
  // Bundesweite Feiertage (Deutschland), an diesen Tagen wird nicht zugestellt
  function isHoliday(d) {
    const md = `${d.getMonth() + 1}-${d.getDate()}`;
    if (['1-1', '5-1', '10-3', '12-25', '12-26'].includes(md)) return true;
    const e = easterSunday(d.getFullYear());
    return [-2, 1, 39, 50].some((off) => {
      const h = new Date(e.getFullYear(), e.getMonth(), e.getDate() + off);
      return h.getMonth() === d.getMonth() && h.getDate() === d.getDate();
    });
  }
  const isWorkday = (d) => d.getDay() !== 0 && d.getDay() !== 6 && !isHoliday(d);
  function addBusinessDays(date, days) {
    const d = new Date(date);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (isWorkday(d)) added++;
    }
    return d;
  }
  // Anlässe für den Hinweis „kommt rechtzeitig vor …“
  function deliveryEvents(year) {
    const e = easterSunday(year);
    const at = (m, d) => new Date(year, m, d);
    return [
      { name: 'Weiberfastnacht', icon: '🎭', date: new Date(year, e.getMonth(), e.getDate() - 52) },
      { name: 'Rosenmontag', icon: '🤡', date: new Date(year, e.getMonth(), e.getDate() - 48) },
      { name: 'dem St. Patrick’s Day', icon: '🍀', date: at(2, 17) },
      { name: 'Halloween', icon: '🎃', date: at(9, 31) },
      { name: 'dem 11.11.', icon: '🎉', date: at(10, 11) },
      { name: 'Nikolaus', icon: '🎅', date: at(11, 6) },
      { name: 'Weihnachten', icon: '🎄', date: at(11, 24) },
      { name: 'Silvester', icon: '🎆', date: at(11, 31) }
    ];
  }
  const dayOnly = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

  function initDelivery(root = document) {
    $$('[data-delivery]', root).forEach((el) => {
      const ds = el.dataset;
      const mode = ds.mode || 'supplier';
      const fmt = (d) => `${FF.strings.days[d.getDay()].slice(0, 2)}., ${d.getDate()}. ${FF.strings.months[d.getMonth()]}`;
      const berlinNow = () => {
        try {
          const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Berlin', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false })
            .formatToParts(new Date()).reduce((o, p) => { o[p.type] = p.value; return o; }, {});
          return new Date(+parts.year, +parts.month - 1, +parts.day, +parts.hour % 24, +parts.minute);
        } catch (err) { return new Date(); }
      };

      // Lieferanten-Modell: Bestellung beim Lieferanten Mo–Fr um X Uhr, Ware nach N Werktagen da, dann Versand
      const supCut = parseInt(ds.supplierCutoff, 10); const cutoffHour = isNaN(supCut) ? 7 : supCut;
      const supDays = parseInt(ds.supplierDays, 10); const supplierDays = isNaN(supDays) ? 2 : supDays;
      const shipDays = parseInt(ds.shipDays, 10) || 1;
      const saturday = ds.saturday === 'true';
      const isDeliveryDay = (d) => d.getDay() !== 0 && !isHoliday(d) && (saturday || d.getDay() !== 6);
      const supplierOrderDay = (now) => {
        const d = dayOnly(now);
        if (isWorkday(d) && now.getHours() < cutoffHour) return d;
        let n = new Date(d);
        do { n.setDate(n.getDate() + 1); } while (!isWorkday(n));
        return n;
      };
      const deliveryFromSupplierDay = (sd) => {
        const arrive = supplierDays > 0 ? addBusinessDays(sd, supplierDays) : new Date(sd);
        const d = new Date(arrive);
        for (let i = 0; i < shipDays; i++) { do { d.setDate(d.getDate() + 1); } while (!isDeliveryDay(d)); }
        return d;
      };

      const eventLine = (now, delivery) => {
        if (ds.events !== 'true') return '';
        const today = dayOnly(now);
        const list = [...deliveryEvents(today.getFullYear()), ...deliveryEvents(today.getFullYear() + 1)]
          .filter((ev) => ev.date >= today && (ev.date - today) / 86400000 <= 45)
          .sort((a, b) => a.date - b.date);
        const ev = list[0];
        if (!ev) return '';
        if (delivery < ev.date) {
          // letzter Bestellzeitpunkt, der noch vor dem Anlass ankommt
          let last = null;
          let sd = supplierOrderDay(now);
          for (let i = 0; i < 60; i++) {
            if (deliveryFromSupplierDay(sd) < ev.date) last = new Date(sd); else break;
            do { sd.setDate(sd.getDate() + 1); } while (!isWorkday(sd));
          }
          let deadline = '';
          if (last && Math.round((last - today) / 86400000) <= 10) {
            deadline = ` Bestell bis <strong>${fmt(last)}, ${cutoffHour}:00 Uhr</strong>.`;
          }
          return `<span class="delivery__event">${ev.icon} Kommt rechtzeitig vor ${esc(ev.name)}!${deadline}</span>`;
        }
        if (delivery.getTime() === ev.date.getTime()) return `<span class="delivery__event delivery__event--late">${ev.icon} Kommt voraussichtlich erst an ${esc(ev.name)}.</span>`;
        return `<span class="delivery__event delivery__event--late">${ev.icon} Kommt voraussichtlich erst nach ${esc(ev.name)}.</span>`;
      };

      const render = () => {
        const now = berlinNow();
        const textEl = $('[data-delivery-text]', el);
        if (mode === 'range') {
          const min = parseInt(ds.min, 10) || 1;
          const max = parseInt(ds.max, 10) || 3;
          const cutoff = parseInt(ds.cutoff, 10) || 14;
          let ship = new Date(now);
          if (!isWorkday(now) || now.getHours() >= cutoff) ship = addBusinessDays(now, 1);
          textEl.innerHTML = `Lieferung voraussichtlich zwischen <strong>${fmt(addBusinessDays(ship, min))}</strong> und <strong>${fmt(addBusinessDays(ship, max))}</strong>`;
          return;
        }
        const delivery = deliveryFromSupplierDay(supplierOrderDay(now));
        const label = esc(ds.label || 'Lieferung voraussichtlich am');
        textEl.innerHTML = `${label} <strong>${fmt(delivery)}</strong>${eventLine(now, dayOnly(delivery))}`;
      };
      render();
      clearInterval(el._t);
      el._t = setInterval(render, 60000);
    });
  }

  /* ---------- Countdown ------------------------------------------------ */
  function easterSunday(y) {
    const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, month - 1, day);
  }
  function seasonTarget(season, now = new Date()) {
    const y = now.getFullYear();
    const pick = (fn) => { const t = fn(y); return t > now ? t : fn(y + 1); };
    switch (season) {
      case 'halloween': return pick((yy) => new Date(yy, 9, 31, 18, 0, 0));
      case 'fasching': return pick((yy) => { const e = easterSunday(yy); return new Date(yy, e.getMonth(), e.getDate() - 48, 11, 11, 0); });
      case 'kobold': return pick((yy) => new Date(yy, 2, 17, 0, 0, 0));
      case 'sommer': return pick((yy) => new Date(yy, 5, 21, 0, 0, 0));
      case 'winter': return pick((yy) => new Date(yy, 11, 24, 0, 0, 0));
      default: return null;
    }
  }
  function initCountdown(root = document) {
    $$('[data-countdown]', root).forEach((el) => {
      let target = null;
      if (el.dataset.date) {
        const [d, t] = el.dataset.date.split(' ');
        const parts = d.split(/[.\-]/).map((n) => parseInt(n, 10));
        // akzeptiert TT.MM.JJJJ oder JJJJ-MM-TT
        target = parts[0] > 31 ? new Date(parts[0], parts[1] - 1, parts[2]) : new Date(parts[2], parts[1] - 1, parts[0]);
        if (t) { const [hh, mm] = t.split(':'); target.setHours(+hh || 0, +mm || 0); }
      }
      if (!target || isNaN(target)) target = seasonTarget(FF.season);
      if (!target) return;
      const units = { d: $('[data-cd="d"]', el), h: $('[data-cd="h"]', el), m: $('[data-cd="m"]', el), s: $('[data-cd="s"]', el) };
      const dateLabel = $('[data-cd-date]', el);
      if (dateLabel) dateLabel.textContent = `${target.getDate()}. ${FF.strings.months[target.getMonth()]} ${target.getFullYear()}`;
      const set = (node, val) => {
        if (!node) return;
        const s = String(val).padStart(2, '0');
        if (node.textContent !== s) {
          node.textContent = s;
          if (!reduceMotion()) { node.classList.remove('tick'); void node.offsetWidth; node.classList.add('tick'); }
        }
      };
      const tick = () => {
        const diff = Math.max(0, target - new Date());
        set(units.d, Math.floor(diff / 86400000));
        set(units.h, Math.floor((diff / 3600000) % 24));
        set(units.m, Math.floor((diff / 60000) % 60));
        set(units.s, Math.floor((diff / 1000) % 60));
        if (diff <= 0) {
          clearInterval(el._t);
          const done = $('[data-cd-done]', el);
          if (done) { done.hidden = false; $('.countdown__units', el).hidden = true; }
        }
      };
      tick();
      clearInterval(el._t);
      el._t = setInterval(tick, 1000);
    });
  }
  FF.seasonTarget = seasonTarget;

  /* ---------- Hero-Slider --------------------------------------------- */
  function initHero(root = document) {
    $$('[data-hero]', root).forEach((hero) => {
      const slides = $$('.hero__slide', hero);
      const dots = $$('[data-hero-dot]', hero);
      if (slides.length < 2) return;
      let i = 0;
      const go = (n) => {
        slides[i].classList.remove('is-active');
        dots[i] && dots[i].setAttribute('aria-current', 'false');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
        dots[i] && dots[i].setAttribute('aria-current', 'true');
      };
      dots.forEach((d, n) => on(d, 'click', () => { go(n); restart(); }));
      const speed = (parseInt(hero.dataset.autoplay, 10) || 0) * 1000;
      let t;
      const restart = () => { clearInterval(t); if (speed && !reduceMotion()) t = setInterval(() => go(i + 1), speed); };
      on(hero, 'mouseenter', () => clearInterval(t));
      on(hero, 'mouseleave', restart);
      restart();
    });
  }

  /* ---------- Karussell-Pfeile ---------------------------------------- */
  on(document, 'click', (e) => {
    const b = e.target.closest('[data-rail-prev],[data-rail-next]');
    if (!b) return;
    const rail = document.getElementById(b.getAttribute('aria-controls'));
    if (!rail) return;
    const dir = b.hasAttribute('data-rail-next') ? 1 : -1;
    rail.scrollBy({ left: dir * rail.clientWidth * 0.8, behavior: 'smooth' });
  });

  /* ---------- Scroll-Reveal ------------------------------------------- */
  let revealIO;
  function initReveal(root = document) {
    const els = $$('[data-reveal]:not(.is-in)', root);
    if (reduceMotion() || !('IntersectionObserver' in window)) { els.forEach((el) => el.classList.add('is-in')); return; }
    revealIO = revealIO || new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('is-in'); revealIO.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach((el) => revealIO.observe(el));
  }

  /* ---------- Kategorie-Filter --------------------------------------- */
  function initFacets(root = document) {
    const container = $('[data-facets-container]', root);
    if (!container || container._init) return;
    container._init = true;
    const sectionId = container.dataset.sectionId;

    const load = async (url, push = true) => {
      const grid = $('[data-product-grid]', container);
      grid && grid.classList.add('is-loading');
      const u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      const html = await (await fetch(u.toString())).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      ['[data-product-grid]', '[data-active-filters]', '[data-facets-form-wrap]', '[data-toolbar-left]', '[data-facets-foot]', '[data-pagination]'].forEach((sel) => {
        const fresh = doc.querySelector(sel);
        const cur = $(sel, container);
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      });
      u.searchParams.delete('section_id');
      if (push) window.history.pushState({ facets: true }, '', u.toString());
      initReveal(container);
    };

    const fromForm = () => {
      const form = $('[data-facets-form]', container);
      const sort = $('[data-sort]', container);
      const params = new URLSearchParams(new FormData(form));
      // leere Preisfelder weglassen
      for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
      if (sort && sort.value) params.set('sort_by', sort.value);
      return `${window.location.pathname}?${params.toString()}`;
    };

    on(container, 'change', (e) => {
      if (e.target.closest('[data-facets-form]') || e.target.matches('[data-sort]')) {
        if (e.target.type === 'number') return;
        load(fromForm());
      }
    });
    on(container, 'input', debounce((e) => {
      if (e.target.type === 'number' && e.target.closest('[data-facets-form]')) load(fromForm());
    }, 600));
    on(container, 'submit', (e) => {
      if (e.target.matches('[data-facets-form]')) { e.preventDefault(); load(fromForm()); }
    });
    on(container, 'click', (e) => {
      const a = e.target.closest('[data-facet-link]');
      if (a) { e.preventDefault(); load(a.href); }
    });
    on(window, 'popstate', (e) => { if (e.state && e.state.facets) load(window.location.href, false); });
  }

  /* ---------- Produkt-Index laden (Finder & Zubehör, ohne Filter-App) -- */
  const ffIndexCache = new Map();
  function ffIndex(source) {
    const base = new URL(source, window.location.origin);
    base.search = '';
    const key = base.pathname;
    if (ffIndexCache.has(key)) return ffIndexCache.get(key);
    const storeKey = 'ff-index3:' + key;
    const cached = (() => {
      try {
        const raw = sessionStorage.getItem(storeKey);
        if (!raw) return null;
        const o = JSON.parse(raw);
        return Date.now() - o.t < 10 * 60 * 1000 ? o.d : null;
      } catch (e) { return null; }
    })();
    if (cached) { try { FF.metaMap = sessionStorage.getItem('ff-map') || ''; } catch (e) { /* egal */ } const pr = Promise.resolve(cached); ffIndexCache.set(key, pr); return pr; }

    const page = async (n) => {
      const u = new URL(base.toString());
      u.searchParams.set('section_id', 'ff-index');
      u.searchParams.set('page', n);
      const html = await (await fetch(u.toString())).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const el = doc.querySelector('[data-ff-index]');
      return el ? JSON.parse(el.textContent) : { pages: 1, products: [] };
    };
    const pr = (async () => {
      try {
        const first = await page(1);
        FF.metaMap = first.map || '';
        try { sessionStorage.setItem('ff-map', FF.metaMap); } catch (e) { /* egal */ }
        const pages = Math.min(first.pages || 1, 30);
        const rest = pages > 1 ? await Promise.all(Array.from({ length: pages - 1 }, (_, i) => page(i + 2))) : [];
        const products = first.products.concat(...rest.map((r) => r.products));
        try { sessionStorage.setItem(storeKey, JSON.stringify({ t: Date.now(), d: products })); } catch (e) { /* zu groß, egal */ }
        return products;
      } catch (e) { return []; }
    })();
    ffIndexCache.set(key, pr);
    return pr;
  }

  const KEY_ALIASES = {
    groesse: ['größe', 'groesse', 'grösse', 'size', 'kostümgröße', 'kleidergröße'],
    farbe: ['farbe', 'color', 'colour', 'farben']
  };
  const META_KEYS = ['zielgruppe', 'thema', 'thema1', 'thema2', 'producttype', 'charakter', 'altersempfehlung', 'saison', 'geschlecht', 'upsell'];
  const asList = (v) => {
    if (v == null || v === '') return [];
    if (Array.isArray(v)) return v.map(String).filter(Boolean);
    const s = String(v).trim();
    if (s.startsWith('[')) { try { return JSON.parse(s).map(String); } catch (e) { /* weiter */ } }
    return s.split(/\s*[,;|]\s*/).filter(Boolean);
  };
  // Alle Werte eines Produkts für ein Merkmal
  function valuesOf(p, key) {
    const k = String(key || '').toLowerCase();
    if (META_KEYS.includes(k) || (p.m && k in p.m)) return asList(p.m && p.m[k]);
    const names = KEY_ALIASES[k] || [k];
    const opt = (p.o || []).find((o) => names.some((n) => o.n === n || o.n.includes(n)));
    if (!opt) return [];
    if (p.vs && p.vs.length && (p.o || []).length === 1) return p.vs.filter((v) => v[2]).map((v) => v[0]);
    return opt.v || [];
  }

  function renderCardHTML(p) {
    const sale = p.c && p.c > p.p;
    const pct = sale ? Math.floor(((p.c - p.p) * 100) / p.c) : 0;
    let quick = '';
    const oneOption = (p.o || []).length <= 1;
    if (settingsQuick() && p.a) {
      if ((p.vs || []).length === 1) {
        quick = `<div class="card__quick"><button type="button" class="quick-btn" data-quick-add="${p.vs[0][1]}" aria-label="${esc(p.t)} in den Warenkorb">${ICON_PLUS}</button></div>`;
      } else if (oneOption && (p.vs || []).length > 1) {
        const id = 'Q' + p.id + Math.random().toString(36).slice(2, 6);
        quick = `<div class="card__quick" data-quick><div class="quick-sizes" id="${id}"><p>${esc(((p.o[0] || {}).n || 'Größe').replace(/^./, (c) => c.toUpperCase()))} wählen</p><div class="quick-sizes__list">${
          p.vs.map((v) => `<button type="button" data-quick-add="${v[1]}"${v[2] ? '' : ' disabled'}>${esc(v[0])}</button>`).join('')
        }</div></div><button type="button" class="quick-btn" data-quick-toggle aria-expanded="false" aria-controls="${id}" aria-label="Schnell hinzufügen: ${esc(p.t)}">${ICON_PLUS}</button></div>`;
      } else {
        quick = `<div class="card__quick"><a class="quick-btn" href="${esc(p.u)}"><span class="visually-hidden">Optionen wählen: ${esc(p.t)}</span>${ICON_ARROW}</a></div>`;
      }
    }
    const badges = !p.a ? '<span class="badge badge--soldout">Ausverkauft</span>'
      : `${sale ? `<span class="badge badge--sale">-${pct}%</span>` : ''}${p.n ? '<span class="badge badge--new">Neu</span>' : ''}`;
    return `<div class="card is-in" data-reveal data-product-id="${p.id}">
      <div class="card__media">
        <a class="card__media-link" href="${esc(p.u)}" tabindex="-1"><span class="visually-hidden">Bilder: ${esc(p.t)}</span>
          ${p.i ? `<img class="card__img card__img--1" src="${esc(p.i)}" alt="${esc(p.t)}" loading="lazy" width="600" height="800">` : ''}
          ${p.i2 ? `<img class="card__img card__img--2" src="${esc(p.i2)}" alt="${esc(p.t)}, Ansicht 2" loading="lazy" width="600" height="800">` : ''}
        </a>
        <div class="badges">${badges}</div>
        ${quick}
      </div>
      <div class="card__info">
        <p class="card__title"><a class="card__link" href="${esc(p.u)}">${esc(p.t)}</a></p>
        <div class="card__meta"><div class="price${sale ? ' price--sale' : ''}"><span class="price__current">${p.pv ? 'ab ' : ''}${formatMoney(p.p)}</span>${sale ? `<s class="price__compare">${formatMoney(p.c)}</s>` : ''}${p.up ? `<span class="price__unit">Grundpreis: ${esc(p.up)}</span>` : ''}</div></div>
      </div>
    </div>`;
  }
  function renderCompactHTML(p, withCombo) {
    const single = (p.vs || []).length === 1 && p.vs[0][2];
    const cp = withCombo && combo() ? comboPrice(p.p) : null;
    return `<div class="upsell" data-product-id="${p.id}">
      <a href="${esc(p.u)}"><span class="visually-hidden">${esc(p.t)}</span>${p.i ? `<img src="${esc(p.i)}" alt="${esc(p.t)}" loading="lazy" width="140" height="175">` : ''}</a>
      <div><a class="upsell__title" href="${esc(p.u)}">${esc(p.t)}</a><div class="price${cp !== null ? ' price--sale' : ''}"><span class="price__current">${formatMoney(cp !== null ? cp : p.p)}</span>${cp !== null ? `<s class="price__compare"><span class="visually-hidden">Statt</span>${formatMoney(p.p)}</s><span class="combo-tag">-${comboAmt()} ${esc(combo().title)}</span>` : ''}${p.up ? `<span class="price__unit">Grundpreis: ${esc(p.up)}</span>` : ''}</div></div>
      ${single ? `<button type="button" class="btn btn--sm btn--primary" data-quick-add="${p.vs[0][1]}" aria-label="${esc(p.t)} hinzufügen">+</button>` : `<a class="btn btn--sm" href="${esc(p.u)}"><span aria-hidden="true">→</span><span class="visually-hidden">${esc(p.t)} ansehen</span></a>`}
    </div>`;
  }
  const ICON_PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  const ICON_CHEV_L = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>';
  const ICON_CHEV_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
  const ICON_ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  const settingsQuick = () => FF.cardQuickAdd !== false;

  const EMOJI = {
    kinder: '🧒', kind: '🧒', jungen: '👦', junge: '👦', mädchen: '👧', maedchen: '👧', baby: '👶', babys: '👶', damen: '👩', frauen: '👩', herren: '🧔', männer: '🧔', unisex: '🧑', erwachsene: '🧑', familie: '👨‍👩‍👧', paare: '💑', gruppe: '👯', gruppen: '👯',
    halloween: '🎃', fasching: '🎭', karneval: '🎭', fastnacht: '🎭', mottoparty: '🥳', party: '🥳', weihnachten: '🎄', silvester: '🎆', ostern: '🐰', oktoberfest: '🍺', 'st. patrick\'s day': '🍀', sommer: '☀️', winter: '❄️', jga: '💍', geburtstag: '🎂',
    hexe: '🧙‍♀️', hexen: '🧙‍♀️', zauberer: '🧙', vampir: '🧛', vampire: '🧛', geist: '👻', geister: '👻', skelett: '💀', zombie: '🧟', teufel: '😈', dämon: '👹', mumie: '🧟', monster: '👾', kürbis: '🎃', fledermaus: '🦇', spinne: '🕷️', clown: '🤡', pirat: '🏴‍☠️', piraten: '🏴‍☠️', prinzessin: '👸', königin: '👑', könig: '🤴', ritter: '🛡️', cowboy: '🤠', indianer: '🪶', polizei: '👮', polizist: '👮', feuerwehr: '🚒', arzt: '🩺', krankenschwester: '🩺', astronaut: '🧑‍🚀', superheld: '🦸', superhelden: '🦸', held: '🦸', einhorn: '🦄', drache: '🐉', dinosaurier: '🦖', tier: '🦁', tiere: '🦁', katze: '🐱', hund: '🐶', löwe: '🦁', tiger: '🐯', biene: '🐝', marienkäfer: '🐞', frosch: '🐸', hase: '🐰', bär: '🐻', fee: '🧚', elfe: '🧝', meerjungfrau: '🧜‍♀️', engel: '👼', sträfling: '🦹', dieb: '🦹', ninja: '🥷', hippie: '☮️', popstar: '🎤', rockstar: '🎸', sportler: '⚽', koch: '👨‍🍳', matrose: '⚓', kobold: '🍀',
    kostüm: '🎭', kostüme: '🎭', kostuem: '🎭', perücke: '💇', perücken: '💇', maske: '🎭', masken: '🎭', hut: '🎩', hüte: '🎩', krone: '👑', kronen: '👑', brille: '🕶️', brillen: '🕶️', bart: '🧔', bärte: '🧔', flügel: '🪽', schwert: '⚔️', schwerter: '⚔️', axt: '🪓', zauberstab: '🪄', zauberstäbe: '🪄', schminke: '💄', accessoire: '✨', accessoires: '✨', zubehör: '✨', aufblasbar: '🎈',
    rot: '🔴', blau: '🔵', grün: '🟢', gelb: '🟡', schwarz: '⚫', weiß: '⚪', weiss: '⚪', lila: '🟣', violett: '🟣', orange: '🟠', braun: '🟤', rosa: '🩷', pink: '🩷', gold: '🥇', silber: '🥈', bunt: '🌈', mehrfarbig: '🌈', grau: '🩶', beige: '🤎'
  };
  function emojiFor(label, custom) {
    const l = String(label || '').toLowerCase().trim();
    if (custom && custom[l]) return custom[l];
    if (EMOJI[l]) return EMOJI[l];
    const word = Object.keys(EMOJI).find((k) => l.includes(k));
    return word ? EMOJI[word] : '';
  }
  function parseEmojiMap(text) {
    const map = {};
    String(text || '').split(/\n/).forEach((line) => {
      const [a, b] = line.split('=');
      if (a && b) map[a.trim().toLowerCase()] = b.trim();
    });
    return map;
  }
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- Kostüm-Finder ------------------------------------------ */
  // Antworten als einfache Objekte, damit sie in die Ergebnis-URL passen
  const PRICE_BANDS = [[0, 15], [15, 25], [25, 40], [40, null]];
  // Ist das Produkt ein Kostüm? Produktart „Kostüm“ oder „Kostümzubehör/Zubehör/Set/Requisite“ mit Kostüm-Titel
  function isCostumeProduct(p) {
    const types = valuesOf(p, 'producttype').map(norm);
    const ct = norm(FF.costumeType || 'Kostüm');
    if (types.includes(ct)) return true;
    return types.some((t) => ['kostümzubehör', 'kostuemzubehoer', 'zubehör', 'set', 'requisite', 'requisiten'].includes(t))
      && /(kostüm|kostuem|overall|jumpsuit|einteiler|plüschanzug|onesie)/i.test(p.t || '');
  }
  function specTest(spec) {
    if (spec.k === '__kostuem') return isCostumeProduct;
    if (spec.k === 'preis') return (p) => p.p >= spec.a * 100 && (spec.b == null || p.p <= spec.b * 100);
    return (p) => valuesOf(p, spec.k).includes(spec.v);
  }
  const specsMatch = (list, specs) => { const tests = specs.map(specTest); return list.filter((p) => tests.every((t) => t(p))); };
  const specLabel = (s) => (s.k === '__kostuem' ? 'Kostüme' : s.k === 'preis' ? (s.b ? (s.a ? `${s.a} bis ${s.b} €` : `bis ${s.b} €`) : `über ${s.a} €`) : s.v);
  const resultsUrl = (source, specs) => `${source}#ff=${encodeURIComponent(JSON.stringify(specs))}`;

  function initFinder(root = document) {
    $$('[data-finder]', root).forEach((finder) => {
      if (finder._init) return;
      finder._init = true;
      const source = finder.dataset.source || '/collections/all';
      let config = [];
      try { config = JSON.parse($('[data-finder-config]', finder).textContent); } catch (e) { config = []; }
      config.forEach((q) => { q.emojiMap = parseEmojiMap(q.emoji); q.key = String(q.key || '').toLowerCase(); });

      const stage = $('[data-finder-stage]', finder);
      const chips = $('[data-finder-chips]', finder);
      const live = $('[data-finder-live]', finder);
      const countEl = $('[data-finder-count]', finder);
      const peek = $('[data-finder-peek]', finder);
      const result = $('[data-finder-result]', finder);
      const grid = $('[data-finder-grid]', finder);
      const bars = $$('[data-finder-progress] span', finder);

      let all = [];
      let answers = []; // { step, spec }
      let step = 0;

      const costumesOnly = finder.dataset.costumesOnly === 'true';
      const specs = () => (costumesOnly ? [{ k: '__kostuem' }] : []).concat(answers.map((a) => a.spec));
      const matches = () => specsMatch(all, specs());

      const animateCount = (el, to) => {
        const from = parseInt(el.textContent, 10) || 0;
        const t0 = performance.now();
        const dur = reduceMotion() ? 0 : 450;
        const tick = (t) => {
          const k = dur ? Math.min(1, (t - t0) / dur) : 1;
          el.textContent = Math.round(from + (to - from) * (1 - Math.pow(1 - k, 3)));
          if (k < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      };

      const renderChips = () => {
        chips.innerHTML = answers.map((a, i) =>
          `<button type="button" class="chip" data-finder-undo="${i}" title="Antwort ändern">${esc(specLabel(a.spec))} <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>`
        ).join('');
      };
      const renderProgress = () => bars.forEach((b, i) => b.classList.toggle('is-done', i < step || !result.hidden));

      const renderLive = () => {
        const m = matches();
        live.hidden = false;
        animateCount(countEl, m.length);
        $('[data-finder-count-label]', finder).textContent = m.length === 1 ? 'passendes Produkt' : 'passende Produkte';
        peek.innerHTML = m.slice(0, 4).map((p) => (p.i ? `<img src="${esc(p.i)}" alt="${esc(p.t)}" loading="lazy" width="38" height="38">` : '')).join('');
      };

      const SIZE_ORDER = (v) => {
        const n = parseInt(String(v).replace(/[^0-9]/g, ''), 10);
        const letters = ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', '2xl', '3xl', 'xxxl'];
        const li = letters.indexOf(String(v).toLowerCase().trim());
        return li >= 0 ? li : isNaN(n) ? 999 : 100 + n;
      };

      const optionsFor = (q) => {
        const pool = matches();
        if (q.key === 'preis') {
          return PRICE_BANDS.map(([a, b]) => {
            const spec = { k: 'preis', a, b };
            return { spec, label: specLabel(spec), emoji: b === 15 ? '🪙' : b === 25 ? '💶' : b === 40 ? '💸' : '💎', count: pool.filter(specTest(spec)).length };
          }).filter((o) => o.count > 0);
        }
        const counts = new Map();
        pool.forEach((p) => new Set(valuesOf(p, q.key)).forEach((v) => counts.set(v, (counts.get(v) || 0) + 1)));
        const opts = Array.from(counts, ([v, c]) => ({ spec: { k: q.key, v }, label: v, count: c, emoji: emojiFor(v, q.emojiMap) }));
        if (q.key === 'groesse' || q.key === 'altersempfehlung') opts.sort((a, b) => SIZE_ORDER(a.label) - SIZE_ORDER(b.label));
        else opts.sort((a, b) => b.count - a.count);
        return opts;
      };

      const renderQuestion = () => {
        let opts = [];
        while (step < config.length) {
          opts = optionsFor(config[step]);
          if (opts.length > 1) break;
          step++;
        }
        renderProgress();
        if (step >= config.length || matches().length <= 1) { finish(); return; }
        const q = config[step];
        const many = opts.length > 8;
        stage.hidden = false;
        stage.innerHTML = `
          <div class="finder__q"><small>Frage ${step + 1} von ${config.length}</small><h3 class="h2">${esc(q.title)}</h3>${q.sub ? `<p class="text-soft">${esc(q.sub)}</p>` : ''}</div>
          <div class="finder__options${many ? ' finder__options--many' : ''}" style="--n:${Math.min(opts.length, 4)}">
            ${opts.map((o, i) => `<button type="button" class="finder__opt" data-finder-opt="${i}" style="--i:${i}">
              ${o.emoji ? `<span class="finder__emoji">${o.emoji}</span>` : `<span class="finder__initial">${esc(String(o.label).charAt(0))}</span>`}
              <b>${esc(o.label)}</b><em>${o.count}</em></button>`).join('')}
          </div>
          <div class="finder__nav">
            ${answers.length ? '<button type="button" class="link-btn" data-finder-back>← Zurück</button>' : ''}
            ${q.skip ? '<button type="button" class="btn btn--ghost btn--sm" data-finder-skip>Egal, weiter</button>' : ''}
          </div>`;
        stage._opts = opts;
        renderLive();
      };

      const finish = () => {
        const m = matches();
        stage.innerHTML = '';
        stage.hidden = true;
        live.hidden = true;
        result.hidden = false;
        const bigCount = $('[data-finder-total]', finder);
        bigCount.textContent = '0';
        animateCount(bigCount, m.length);
        $('[data-finder-total-label]', finder).textContent = m.length === 1 ? 'Produkt gefunden' : 'Produkte gefunden';
        $('[data-finder-result-text]', finder).textContent = m.length
          ? (answers.length ? `Deine Auswahl: ${answers.map((a) => specLabel(a.spec)).join(' · ')}` : 'Alle unsere Lieblinge für dich.')
          : 'Dazu haben wir leider nichts gefunden. Probier eine andere Antwort!';
        grid.innerHTML = m.slice(0, 4).map(renderCardHTML).join('');
        const allBtn = $('[data-finder-all]', finder);
        const oneBtn = $('[data-finder-one]', finder);
        allBtn.hidden = m.length < 2;
        allBtn.href = resultsUrl(source, specs());
        $('[data-finder-all-label]', finder).textContent = `Alle ${m.length} anzeigen`;
        oneBtn.hidden = m.length !== 1;
        if (m.length === 1) oneBtn.href = m[0].u;
        renderProgress();
        if (m.length) document.dispatchEvent(new CustomEvent('ff:celebrate', { detail: { source: result } }));
      };

      const answer = (opt) => {
        answers.push({ step, spec: opt.spec });
        step++;
        renderChips();
        renderQuestion();
      };

      const goTo = (toIndex) => {
        if (toIndex < 0) return;
        step = toIndex < answers.length ? answers[toIndex].step : 0;
        answers = answers.slice(0, toIndex);
        result.hidden = true;
        renderChips();
        renderQuestion();
      };

      on(finder, 'click', (e) => {
        const o = e.target.closest('[data-finder-opt]');
        if (o && stage._opts) {
          $$('.finder__opt', stage).forEach((b) => b.classList.toggle('is-selected', b === o));
          const opt = stage._opts[parseInt(o.dataset.finderOpt, 10)];
          stage._opts = null;
          setTimeout(() => answer(opt), reduceMotion() ? 0 : 220);
          return;
        }
        if (e.target.closest('[data-finder-skip]')) { step++; renderQuestion(); return; }
        if (e.target.closest('[data-finder-finish]')) { finish(); return; }
        if (e.target.closest('[data-finder-back]')) { goTo(answers.length - 1); return; }
        const undo = e.target.closest('[data-finder-undo]');
        if (undo) { goTo(parseInt(undo.dataset.finderUndo, 10)); return; }
        if (e.target.closest('[data-finder-restart]')) { answers = []; step = 0; result.hidden = true; renderChips(); renderQuestion(); }
      });

      const adminReport = () => {
        const admin = $('[data-finder-admin-list]', finder);
        if (!admin) return;
        const keysOrder = ['zielgruppe', 'thema', 'thema1', 'thema2', 'producttype', 'charakter', 'altersempfehlung', 'saison', 'geschlecht'];
        const mapParts = String(FF.metaMap || '').split('|');
        const mapInfo = keysOrder.map((k, i) => `${k} → ${mapParts[i] ? '<b>' + esc(mapParts[i]) + '</b>' : '<span style="color:var(--sale)">nicht gefunden</span>'}`).join(' · ');
        admin.innerHTML = `<div>📦 ${all.length} verfügbare Produkte geladen.</div><div>🔎 Gefundene Metafelder: ${mapInfo}</div>` + config.map((q) => {
          if (q.key === 'preis') return `<div>✅ <b>${esc(q.title)}</b>: Preis ist immer verfügbar</div>`;
          const withVal = all.filter((p) => valuesOf(p, q.key).length).length;
          const distinct = new Set(all.flatMap((p) => valuesOf(p, q.key))).size;
          return `<div>${withVal ? '✅' : '⚠️'} <b>${esc(q.title)}</b> (${esc(q.key)}): ${withVal ? `${withVal} Produkte mit ${distinct} verschiedenen Werten` : 'kein Produkt hat dieses Merkmal, die Frage wird übersprungen.'}</div>`;
        }).join('');
      };

      const start = async () => {
        stage.classList.add('is-loading');
        all = (await ffIndex(source)).filter((p) => p.a && (!costumesOnly || isCostumeProduct(p)));
        stage.classList.remove('is-loading');
        adminReport();
        if (!all.length) {
          stage.innerHTML = `<div class="center"><p>Stöber doch direkt in allen Kostümen!</p><a class="btn btn--primary" href="${esc(source)}">Alle Produkte</a></div>`;
          return;
        }
        renderQuestion();
      };
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(([en]) => { if (en.isIntersecting) { io.disconnect(); start(); } }, { rootMargin: '600px' });
        io.observe(finder);
      } else start();
    });
  }

  /* ---------- Finder-Ergebnisliste auf der Kategorieseite (#ff=…) ----- */
  async function initFinderResults() {
    const box = $('[data-ff-results]');
    if (!box || !location.hash.startsWith('#ff=')) return;
    let list = [];
    try { list = JSON.parse(decodeURIComponent(location.hash.slice(4).replace(/\+/g, ' '))); } catch (e) { return; }
    if (!Array.isArray(list)) return;
    const container = box.closest('[data-facets-container]') || document;
    $$('[data-product-grid], [data-pagination], .toolbar, [data-active-filters], .coll-hero', container).forEach((el) => { el.hidden = true; });
    box.hidden = false;
    const gridEl = $('[data-ff-results-grid]', box);
    gridEl.innerHTML = '<div class="finder__loading"><span class="finder__spinner"></span> Ergebnisse werden geladen …</div>';
    const all = (await ffIndex(location.pathname)).filter((p) => p.a);
    const m = specsMatch(all, list);
    $('[data-ff-results-count]', box).textContent = m.length;
    $('[data-ff-results-label]', box).textContent = m.length === 1 ? 'Produkt passt zu deiner Auswahl' : 'Produkte passen zu deiner Auswahl';
    $('[data-ff-results-chips]', box).innerHTML = list.map((s) => `<span class="chip">${esc(specLabel(s))}</span>`).join('');
    let shown = 24;
    const more = $('[data-ff-results-more]', box);
    const render = () => {
      gridEl.innerHTML = m.length ? m.slice(0, shown).map(renderCardHTML).join('') : '<p class="text-soft">Leider nichts gefunden.</p>';
      more.hidden = m.length <= shown;
    };
    on(more, 'click', () => { shown += 24; render(); });
    render();
    window.scrollTo(0, 0);
  }

  /* ---------- Passendes Zubehör (Warenkorb & Produktseite) ----------- */
  // Regel: gleiches Thema 1 + gleiche Zielgruppe, aber anderer Produkttyp.
  // Kostüm -> passendes Zubehör (alles, was kein Kostüm ist); alles andere -> passendes Kostüm.
  const norm = (v) => String(v || '').toLowerCase().trim();
  // Geschlecht: aus Metafeld geschlecht (falls vorhanden), Zielgruppe und Titel. 'f', 'm' oder '' (neutral/unisex)
  // Wortanfang reicht bei Damen/Herren/Mädchen/Jungen (Damenkostüm, Herrenperücke), sonst ganzes Wort
  const RX_F = /(^|[^a-zäöüß])(damen|frauen|mädchen|maedchen)|(^|[^a-zäöüß])(dame|frau|girls?|women|ladies|lady|weiblich)([^a-zäöüß]|$)/i;
  const RX_M = /(^|[^a-zäöüß])(herren|männer|maenner|jungen)|(^|[^a-zäöüß])(herr|mann|junge|boys?|men|männlich)([^a-zäöüß]|$)/i;
  const RX_U = /(^|[^a-zäöüß])(unisex|divers)([^a-zäöüß]|$)/i;
  // Geschlecht steht im Metafeld charakter (Damen, Herren, Mädchen, Jungen, Unisex …).
  // Fehlt es, wird es aus Metafeld geschlecht bzw. Titel erkannt.
  // Charakter-Werte (seit 10.10.2026): Herren, Damen, Erwachsene, Jungen, Mädchen, Kinder, Babys.
  // „Erwachsene“ = Erwachsene unisex, „Kinder“ = Kinder unisex. Altwerte „Unisex“/„Baby“ werden weiter verstanden.
  const GENDER_MAP = [
    ['unisex', /^(unisex|divers|alle|beide)$/],
    ['erwachsene', /^(erwachsene|erwachsener|erwachsen|adults?)$/],
    ['damen', /^(damen|dame|frau|frauen|women|ladies|lady|weiblich)$/],
    ['herren', /^(herren|herr|mann|männer|maenner|men|männlich)$/],
    ['maedchen', /^(mädchen|maedchen|girls?)$/],
    ['jungen', /^(jungen|junge|boys?)$/],
    ['kinder', /^(kinder|kind|kids)$/],
    ['babys', /^(babys|baby|babies|kleinkind|kleinkinder)$/]
  ];
  const ADULT_G = ['herren', 'damen', 'erwachsene'];
  const KID_G = ['jungen', 'maedchen', 'kinder'];
  const genderWord = (v) => { const n = norm(v); const hit = GENDER_MAP.find(([, rx]) => rx.test(n)); return hit ? hit[0] : null; };
  function genderOf(p, meta) {
    const fields = [].concat(meta ? asList(meta.charakter) : [], p && !meta ? valuesOf(p, 'charakter') : [], meta ? asList(meta.geschlecht) : [], p && !meta ? valuesOf(p, 'geschlecht') : []);
    const found = [...new Set(fields.map(genderWord).filter(Boolean))];
    if (found.length === 1) return found[0];
    if (found.length > 1) {
      // mehrere Werte: „Herren, Damen“ = Erwachsene, „Jungen, Mädchen“ = Kinder
      if (found.every((g) => ADULT_G.includes(g))) return 'erwachsene';
      if (found.every((g) => KID_G.includes(g) || g === 'babys')) return found.includes('babys') && found.length === 1 ? 'babys' : 'kinder';
      return 'unisex';
    }
    // kein Charakter gepflegt: nur eindeutige Wörter im Titel
    const t = p ? String(p.t || '') : '';
    if (/(^|[^a-zäöüß])unisex/i.test(t)) return 'unisex';
    if (/(^|[^a-zäöüß])(mädchen|maedchen)/i.test(t)) return 'maedchen';
    if (/(^|[^a-zäöüß])jungen/i.test(t)) return 'jungen';
    const f = RX_F.test(t); const m = RX_M.test(t);
    if (f && !m) return 'damen';
    if (m && !f) return 'herren';
    return '';
  }
  // Was darf zu welchem Kostüm? (Kostüm -> erlaubte Charakter-Werte beim Zubehör)
  const GENDER_ALLOWED = {
    herren: ['herren', 'erwachsene'],
    damen: ['damen', 'erwachsene'],
    erwachsene: ['herren', 'damen', 'erwachsene'],
    jungen: ['jungen', 'kinder'],
    maedchen: ['maedchen', 'kinder'],
    kinder: ['jungen', 'maedchen', 'kinder'],
    babys: ['babys', 'kinder']
  };
  // a = Kostüm, b = Zubehör. Leer oder Altwert „Unisex“ beim Zubehör passt; Herren/Damen/Erwachsene und
  // Kinder-Werte werden nie gemischt (Alterstrennung).
  function genderFits(a, b) {
    if (!b || b === 'unisex' || !a || a === 'unisex') return true;
    const allowed = GENDER_ALLOWED[a];
    return allowed ? allowed.includes(b) : a === b;
  }
  // Kostüm ohne (oder mit Alt-)Charakter: Gruppe aus dem Alter ableiten
  // Zubehör mit Altwert „Unisex“: gilt als neutral innerhalb seiner Altersgruppe (Erwachsene/Kinder/Babys)
  const accGender = (p) => { const g = genderOf(p); return g === 'unisex' ? (genderFromAge(ageOf(p)) || 'unisex') : g; };
  const genderFromAge = (age) => ({ adult: 'erwachsene', kid: 'kinder', baby: 'babys' }[age] || '');
  // Altersgruppe aus Metafeld altersempfehlung, sonst Zielgruppe, Geschlecht (Mädchen/Jungen) oder Titel:
  // 'adult', 'kid', 'baby' oder '' (für alle / unbekannt)
  function ageOf(p, meta) {
    const pick = (k) => (meta ? asList(meta[k]) : valuesOf(p, k)).join(' ').toLowerCase();
    const fromText = (t) => {
      if (!t) return '';
      if (/(alle|jedes alter|unisex)/.test(t)) return '';
      if (/(erwachsen|adult|damen|herren|jugend)/.test(t) && /(kind|kids|mädchen|maedchen|jungen)/.test(t)) return '';
      if (/(baby|babies|kleinkind|monat|geburt)/.test(t)) return 'baby';
      if (/(erwachsen|adult|teen|jugend)/.test(t)) return 'adult';
      const m = t.match(/(?:ab|von)?\s*(\d{1,2})\s*(?:[-–bis]+\s*\d{1,2})?\s*(?:j|jahr)/) || t.match(/ab\s*(\d{1,2})/);
      if (m) { const n = parseInt(m[1], 10); return n >= 14 ? 'adult' : (n <= 2 ? 'baby' : 'kid'); }
      if (/(kind|kids|mädchen|maedchen|jungen|junge)/.test(t)) return 'kid';
      if (/(damen|herren|frau|mann|männer)/.test(t)) return 'adult';
      return '';
    };
    return fromText(pick('altersempfehlung')) || fromText(pick('zielgruppe'))
      || fromText(pick('charakter')) || fromText(p ? String(p.t || '').toLowerCase() : '');
  }
  const ageFits = (a, b) => !a || !b || a === b;
  const GENDER_LABEL = { damen: 'Damen', herren: 'Herren', erwachsene: 'Erwachsene', maedchen: 'Mädchen', jungen: 'Jungen', kinder: 'Kinder', babys: 'Babys', unisex: 'Unisex (Altwert)' };
  const isCostumeType = (t) => norm(t) === norm(FF.costumeType || 'Kostüm');
  const typeList = (v) => String(v || '').split(/\s*[,;\n]\s*/).map(norm).filter(Boolean);
  // Teilwort reicht: „Deko“ schließt auch „Dekoration“ und „Halloween Deko“ aus
  const isExcludedType = (t) => typeList(FF.upsellExclude || 'Deko').some((x) => norm(t).includes(x));
  const isUniversalType = (t) => typeList(FF.upsellUniversal).some((x) => norm(t).includes(x));

  // Regeln: Produktart != Kostüm/Deko (bzw. umgekehrt Kostüm), Geschlecht gleich oder Unisex (immer).
  // Stufe 1: gleiches Thema1 + gleiche Saison. Unter 5 Treffern wird gelockert:
  // 2: Thema1 andere Saison, 3: Thema2-Verwandtschaft (z. B. Thema1 Gefängnis / Thema2 Dieb),
  // 4: Zubehör, das zu jedem Kostüm passt (Einstellung), 5: Zubehör ohne festes Thema (Allgemein/Basic),
  // 6: fehlende Produktarten aus der Reihenfolge auffüllen. Ziel: mindestens 4 verschiedene Produktarten. Gleiches Thema2 und Zielgruppe kommen zuerst.
  async function fillUpsell(box, meta, excludeIds) {
    const source = box.dataset.source;
    if (!source || !meta) return false;
    const limit = parseInt(box.dataset.upsellLimit, 10) || 3;
    const mode = box.dataset.upsellMode || 'cards';
    const all = await ffIndex(source);
    const selfP = all.find((p) => String(p.id) === String(meta._id || excludeIds[0]));

    // Von dir gepflegte Upsells (Metafeld upsell mit Artikelnummern) haben Vorrang vor allen Regeln
    const manualCodes = asList(meta.upsell).map((c) => c.trim()).filter(Boolean);
    if (manualCodes.length) {
      const matchSku = (p, code) => (p.s || []).some((sku) => {
        const a = norm(sku); const c = norm(code);
        return a === c || (a.startsWith(c) && /[^a-z0-9]/.test(a.charAt(c.length)));
      });
      const found = []; const missing = [];
      manualCodes.forEach((code, i) => {
        const hit = all.filter((p) => !excludeIds.includes(String(p.id)) && matchSku(p, code));
        const avail = hit.filter((p) => p.a);
        if (avail.length) avail.forEach((p) => { if (!found.some((x) => x.p === p)) found.push({ p, tier: i }); });
        else missing.push(`${code}${hit.length ? ' (ausverkauft)' : ' (nicht gefunden)'}`);
      });
      if (FF.debugUpsell && box.tagName === 'SECTION') upsellDebugManual(box, manualCodes, found, missing, all.length);
      if (found.length) {
        const myTypesM = asList(meta.producttype);
        const iAmCostumeM = myTypesM.length ? myTypesM.some(isCostumeType) : true;
        const outfitElM = $('[data-outfit]', box);
        if (iAmCostumeM && outfitElM && box.dataset.outfitMode && box.dataset.outfitMode !== 'cards') {
          buildOutfit(box, outfitElM, found, selfP, null, { manual: true });
          return true;
        }
        const head = $('[data-upsell-heading]', box);
        if (head && mode !== 'compact') head.innerHTML = iAmCostumeM ? (box.dataset.headingAccessory || head.innerHTML) : (box.dataset.headingCostume || head.innerHTML);
        const reason = $('[data-upsell-reason]', box);
        if (reason) reason.textContent = 'Von uns passend zusammengestellt';
        const comboOn = mode === 'compact' && iAmCostumeM && !!combo();
        if (comboOn && head) head.innerHTML = `${esc(combo().title)}: ${comboAmt()} günstiger dazu`;
        $('[data-upsell-list]', box).innerHTML = found.slice(0, mode === 'compact' ? limit : Math.max(limit, 8))
          .map((x) => (mode === 'compact' ? renderCompactHTML(x.p, comboOn) : renderCardHTML(x.p))).join('');
        box.hidden = false;
        return true;
      }
      // nichts Verfügbares gefunden: normale Regeln greifen
    }
    const selfLike = selfP || { t: meta._title || '', m: {}, o: [] };
    let myGender = genderOf(selfLike, meta);
    const myTypes = asList(meta.producttype);
    const iAmCostume = myTypes.length ? myTypes.some(isCostumeType) : true;
    const mine = (k) => asList(meta[k]).map(norm);
    const myThema1 = mine('thema1');
    const has = (p, k, list) => list.length > 0 && valuesOf(p, k).some((v) => list.includes(norm(v)));

    // „Kostümzubehör“/„Set“ mit Kostüm-Titel (Overall, Jumpsuit, …) ist in Wahrheit ein Kostüm
    const GENERIC_ACC = ['kostümzubehör', 'kostuemzubehoer', 'zubehör', 'set', 'requisite', 'requisiten'];
    const looksLikeCostume = (p) => valuesOf(p, 'producttype').some((t) => GENERIC_ACC.includes(norm(t)))
      && /(kostüm|kostuem|overall|jumpsuit|einteiler|plüschanzug|onesie)/i.test(p.t || '');
    const typeOk = (p) => {
      const t = valuesOf(p, 'producttype');
      if (!t.length || t.some(isExcludedType)) return false;
      const costume = t.some(isCostumeType) || looksLikeCostume(p);
      return iAmCostume ? !costume : costume;
    };
    const myAge = ageOf(selfLike, meta);
    // Kostüm ohne Charakter oder mit Altwert „Unisex“: Gruppe (Erwachsene/Kinder/Babys) aus dem Alter ableiten
    if (!myGender || myGender === 'unisex') myGender = genderFromAge(myAge) || myGender;
    const myAgeText = mine('altersempfehlung');
    // Geschlecht gilt immer; das Alter wird erst ganz am Schluss gelockert
    const base = all.filter((p) => p.a && !excludeIds.includes(String(p.id)) && typeOk(p) && genderFits(myGender, accGender(p)));
    // Alter nur bei Produktarten, bei denen es wirklich drauf ankommt (Perücke, Hut, Maske, Kleidung, Schminke …)
    const ageTypes = typeList(FF.upsellAgeTypes);
    const ageMatters = (p) => valuesOf(p, 'producttype').some((t) => ageTypes.includes(norm(t)));
    const ageOk = (p) => !ageMatters(p) || ageFits(myAge, ageOf(p));
    if (!base.length) return false;
    const mySeason = mine('saison');
    const myThema2 = mine('thema2');
    const myZiel = mine('zielgruppe');
    const sameSeason = (p) => !mySeason.length || has(p, 'saison', mySeason);
    // Stufen: erst streng, dann lockerer, bis genug Vorschläge da sind (Geschlecht und Ausschlüsse gelten immer)
    const sameZiel = (p) => !myZiel.length || !valuesOf(p, 'zielgruppe').length || has(p, 'zielgruppe', myZiel);
    const genericThemes = typeList(FF.upsellGenericThemes || 'Allgemein, Basic, Universal, Party');
    const isGenericTheme = (p) => { const t = valuesOf(p, 'thema1').map(norm); return !t.length || t.some((x) => genericThemes.some((g) => x.includes(g))); };
    const primaryType = (p) => norm(valuesOf(p, 'producttype').find((t) => !isCostumeType(t)) || 'zubehör');
    const typeOrder = typeList(box.dataset.typeOrder || 'Perücke, Hut, Haarreif, Maske, Zähne, Make-up');
    const inOrder = (p) => { const k = primaryType(p); return typeOrder.some((o) => k === o || k.startsWith(o) || o.startsWith(k)); };
    // Stufen: erst streng, dann lockerer, bis genug verschiedene Produktarten da sind
    // (Geschlecht, Kostüm-/Deko-Ausschluss gelten immer)
    // Schlüsselwörter aus dem Titel (z. B. „Skelett“, „Pirat“, „Vampir“), weil Thema/Saison nicht überall gepflegt sind.
    // Allgemeine Wörter und alle Produktarten (Hut, Perücke …) zählen nicht.
    const typeWords = new Set(all.flatMap((p) => valuesOf(p, 'producttype')).flatMap((t) => norm(t).split(/\s+/)));
    const STOP = new Set('kostüm kostueme kostüme kostuem verkleidung outfit damen herren kinder kind kids jungen junge mädchen maedchen baby babys unisex erwachsene erwachsenen frauen männer halloween fasching karneval deluxe luxus premium classic klassisch sexy set teilig teiliges mit und oder für fuer der die das den dem des ein eine einer zum zur von vom aus in im am als mit ohne lang kurz groß gross klein größe groesse einheitsgröße one size schwarz weiß weiss rot blau grün gruen gelb orange lila pink rosa grau braun gold silber bunt mehrfarbig xs s m l xl xxl poncho overall jumpsuit onesie kleid tunika umhang anzug kapuze plüsch einteiler abenteuer abenteuerlich tierisch tierische niedlich niedliches lustig lustiges gruselig gruseliges cool party motto mottoparty karnevals faschings verkleiden dreiteilig zweiteilig teilig accessoire accessoires zubehör kostümzubehör'.split(' '));
    const stem = (w) => { let x = w; for (const suf of ['innen', 'en', 'er', 'e', 'n', 's']) { if (x.length - suf.length >= 4 && x.endsWith(suf)) { x = x.slice(0, -suf.length); break; } } return x; };
    const keywordsOf = (title) => [...new Set(norm(title).replace(/[^a-zäöüß0-9 ]+/g, ' ').split(/\s+/)
      .filter((w) => w.length >= 4 && !STOP.has(w) && !typeWords.has(w) && !/^\d+$/.test(w) && !/(kostüm|kostuem|kostüme)$/.test(w)).map(stem))];
    const selfTitle = (selfP && selfP.t) || meta._title || '';
    const myKeys = keywordsOf(selfTitle);
    const keyHits = (p) => { const t = norm(p.t).replace(/[^a-zäöüß0-9]+/g, ' '); return myKeys.filter((k) => t.includes(k)).length; };
    const themeOrKey = (p) => has(p, 'thema1', myThema1) || keyHits(p) > 0;
    // Titel-Treffer (z. B. „Spinne“) vor Thema1-Treffern (z. B. das breite „Tiere“)
    const stages = [
      (p) => keyHits(p) > 0 && sameSeason(p),
      (p) => keyHits(p) > 0,
      (p) => has(p, 'thema1', myThema1) && sameSeason(p),
      (p) => has(p, 'thema1', myThema1),
      (p) => (has(p, 'thema2', myThema1) || has(p, 'thema1', myThema2) || has(p, 'thema2', myThema2)) && sameSeason(p),
      (p) => iAmCostume && valuesOf(p, 'producttype').some(isUniversalType) && sameSeason(p) && sameZiel(p),
      (p) => iAmCostume && isGenericTheme(p) && sameSeason(p) && sameZiel(p),
      'fill'
    ];
    const minTypes = parseInt(FF.upsellMinTypes, 10) || 4;
    const minCount = parseInt(FF.upsellMin, 10) || 5;
    const stageOf = new Map();
    const typesNow = () => new Set([...stageOf.keys()].map(primaryType)).size;
    const enough = () => (iAmCostume ? typesNow() >= minTypes : stageOf.size >= minCount);
    const runStages = (offset, filter) => {
      for (let i = 0; i < stages.length; i++) {
        if ((i > 0 || offset > 0) && enough()) return;
        const st = offset + i;
        if (stages[i] === 'fill') {
          // fehlende Produktarten aus deiner Reihenfolge auffüllen (je Art höchstens 6 Teile)
          if (!iAmCostume) return;
          const have = new Set([...stageOf.keys()].map(primaryType));
          const perType = new Map();
          base.filter((p) => filter(p) && !stageOf.has(p) && sameSeason(p) && sameZiel(p) && inOrder(p) && !have.has(primaryType(p)))
            .forEach((p) => {
              const k = primaryType(p);
              const n = perType.get(k) || 0;
              if (n < 6) { perType.set(k, n + 1); stageOf.set(p, st); }
            });
          continue;
        }
        base.forEach((p) => { if (filter(p) && !stageOf.has(p) && stages[i](p)) stageOf.set(p, st); });
      }
    };
    runStages(0, ageOk);                 // alle Stufen mit passendem Alter
    if (!enough()) runStages(stages.length, () => true); // ganz zum Schluss: Alter lockern
    if (FF.debugUpsell && box.tagName === 'SECTION') upsellDebug(box, {
      selfP, selfTitle, looksLikeCostume, myGender, myAge, myKeys, myThema1, mySeason, all, excludeIds, typeOk, ageOk, ageMatters, stageOf, keyHits, has, themeOrKey
    });
    if (!stageOf.size) { if (FF.debugUpsell && box.tagName === 'SECTION') box.hidden = false; return false; }
    const score = (p) => Math.min(keyHits(p), 2) * 4 + (has(p, 'thema1', myThema1) ? 3 : 0) + (has(p, 'thema2', myThema2) ? 2 : 0) + (has(p, 'zielgruppe', myZiel) ? 2 : 0) + (has(p, 'altersempfehlung', myAgeText) ? 2 : 0)
      + (myGender && !['unisex', 'erwachsene', 'kinder'].includes(myGender) && genderOf(p) === myGender ? 1 : 0);
    const scored = [...stageOf.entries()].map(([p, st]) => ({ p, tier: st * 20 - score(p) })).sort((a, b) => a.tier - b.tier);
    const keyWord = myKeys.length ? (selfTitle.split(/\s+/).find((w) => norm(w).includes(myKeys[0])) || '') : '';
    const themaHits = [...stageOf.keys()].filter((p) => has(p, 'thema1', myThema1)).length;
    const keyHitsAll = [...stageOf.keys()].filter((p) => keyHits(p) > 0).length;
    const lead = keyHitsAll >= themaHits && keyWord ? keyWord : (asList(meta.thema1)[0] || keyWord);
    const why = [lead || asList(meta.thema)[0] || 'deinem Look', GENDER_LABEL[myGender] || ''];

    const outfitEl = $('[data-outfit]', box);
    if (iAmCostume && outfitEl && box.dataset.outfitMode && box.dataset.outfitMode !== 'cards') {
      buildOutfit(box, outfitEl, scored, selfP, why);
      return true;
    }
    const picked = scored.slice(0, limit).map((x) => x.p);

    // Überschrift passend zur Richtung
    const head = $('[data-upsell-heading]', box);
    if (head) head.innerHTML = iAmCostume ? (box.dataset.headingAccessory || head.innerHTML) : (box.dataset.headingCostume || head.innerHTML);
    const reason = $('[data-upsell-reason]', box);
    if (reason) reason.textContent = `Passend zu „${why[0]}“${why[1] ? ` für ${why[1]}` : ''}`;
    const list = $('[data-upsell-list]', box);
    const comboOn = mode === 'compact' && iAmCostume && !!combo();
    if (comboOn && head) head.innerHTML = `${esc(combo().title)}: ${comboAmt()} günstiger dazu`;
    list.innerHTML = picked.map((p) => (mode === 'compact' ? renderCompactHTML(p, comboOn) : renderCardHTML(p))).join('');
    box.hidden = false;
    return true;
  }
  // Diagnose für dich im Theme-Editor (oder mit ?ff_debug=1): warum welches Zubehör (nicht) vorgeschlagen wird
  function upsellDebugManual(box, codes, found, missing, total) {
    let el = $('.ff-debug', box);
    if (!el) { el = document.createElement('details'); el.className = 'ff-debug'; (box.querySelector('.page-width') || box).appendChild(el); }
    el.innerHTML = `<summary>🔧 Upselling-Diagnose (nur für dich sichtbar)</summary>
      <p><b>Manuelle Upsells aus Metafeld upsell:</b> ${esc(codes.join(', '))} · Index: ${total} Produkte</p>
      <p>✅ Gefunden: ${found.length ? found.map((x) => esc(x.p.t)).join(', ') : 'keine'}</p>
      ${missing.length ? `<p>❌ Fehlt: ${esc(missing.join(', '))}</p>` : ''}
      <p>${found.length ? 'Es werden nur deine manuellen Upsells gezeigt.' : 'Keiner verfügbar, deshalb greifen die automatischen Regeln.'}</p>`;
  }
  function upsellDebug(box, d) {
    let el = $('.ff-debug', box);
    if (!el) { el = document.createElement('details'); el.className = 'ff-debug'; (box.querySelector('.page-width') || box).appendChild(el); }
    const AGE = { adult: 'Erwachsene', kid: 'Kinder', baby: 'Baby', '': 'alle' };
    const rel = d.all.filter((p) => p.a && !d.excludeIds.includes(String(p.id)) && p !== d.selfP && d.themeOrKey(p));
    const why = (p) => {
      const r = [];
      if (!d.typeOk(p)) r.push(valuesOf(p, 'producttype').some(isCostumeType) || !d.looksLikeCostume(p) ? `Produktart „${valuesOf(p, 'producttype').join(', ') || 'leer'}“ ausgeschlossen` : `„${valuesOf(p, 'producttype').join(', ')}“, aber Titel klingt nach Kostüm`);
      const g = accGender(p);
      if (!genderFits(d.myGender, g)) r.push(`Charakter ${GENDER_LABEL[g] || g} passt nicht zu ${GENDER_LABEL[d.myGender] || d.myGender}`);
      if (!d.ageOk(p)) r.push(`Alter ${AGE[ageOf(p)]} passt nicht`);
      return r;
    };
    const rows = rel.slice(0, 60).map((p) => {
      const r = why(p);
      const st = d.stageOf.has(p) ? `✅ Stufe ${d.stageOf.get(p) + 1}` : (r.length ? '❌ ' + r.join(', ') : '⏸️ nicht nötig');
      const gp = genderOf(p);
      return `<tr><td>${esc(p.t)}</td><td>${esc(valuesOf(p, 'producttype').join(', '))}</td><td>${esc(GENDER_LABEL[gp] || 'leer')} / ${AGE[ageOf(p)]}</td><td>${d.keyHits(p) ? 'Titel' : ''}${d.has(p, 'thema1', d.myThema1) ? ' Thema1' : ''}</td><td>${st}</td></tr>`;
    }).join('');
    el.innerHTML = `<summary>🔧 Upselling-Diagnose (nur für dich sichtbar)</summary>
      <p><b>Produkt:</b> ${esc(d.selfTitle || '?')}${d.selfP ? '' : ' <i>(nicht im Index gefunden)</i>'} · Index: ${d.all.length} Produkte · Charakter: <b>${esc(GENDER_LABEL[d.myGender] || d.myGender || 'unbekannt')}</b> (erlaubt beim Zubehör: ${esc((GENDER_ALLOWED[d.myGender] || []).map((x) => GENDER_LABEL[x]).concat('leer', 'Unisex (Altwert)').join(', ') || 'alle')}) · Alter: <b>${AGE[d.myAge]}</b> · Saison: <b>${esc(d.mySeason.join(', ') || 'leer')}</b> · Thema1: <b>${esc(d.myThema1.join(', ') || 'leer')}</b> · Titel-Wörter: <b>${esc(d.myKeys.join(', ') || 'keine')}</b></p>
      <p>${rel.length} Produkte passen über Titel oder Thema1, davon ${[...d.stageOf.keys()].filter((p) => rel.includes(p)).length} vorgeschlagen. Insgesamt ${d.stageOf.size} Vorschläge.</p>
      <div style="overflow:auto;max-height:420px"><table><tr><th>Produkt</th><th>Produktart</th><th>Charakter / Alter</th><th>Treffer</th><th>Ergebnis</th></tr>${rows}</table></div>`;
  }

  /* ---------- Kombi-Rabatt (Kostüm kaufen -> X € auf jedes Zubehör) --- */
  const combo = () => (FF.combo && FF.combo.amount > 0 ? FF.combo : null);
  const comboPrice = (cents) => Math.max(0, cents - (combo() ? combo().amount : 0));
  const comboAmt = () => formatMoney(combo().amount).replace(/[.,]00(?=\D*$)/, '');
  const ICON_GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>';
  const isCostumeMeta = (meta) => { const t = asList(meta && meta.producttype); return t.length ? t.some(isCostumeType) : null; };

  async function cartHasCostume() {
    try {
      const cart = await (await fetch(FF.routes.cart + '.js')).json();
      if (!cart.items.length) return false;
      const idx = await ffIndex(routes_all());
      return cart.items.some((it) => { const p = idx.find((x) => x.id === it.product_id); return p && valuesOf(p, 'producttype').some(isCostumeType); });
    } catch (e) { return false; }
  }
  const routes_all = () => (FF.routes.allProducts || '/collections/all');

  // Kombi-Rabatt automatisch einlösen: Code rein, sobald ein Kostüm im Warenkorb liegt, raus, wenn nicht
  let comboSyncing = false;
  async function syncComboCode() {
    let code = '';
    try { code = FF.comboKey ? decodeURIComponent(escape(atob(FF.comboKey))).trim() : ''; } catch (e) { code = ''; }
    if (!code || comboSyncing) return;
    comboSyncing = true;
    try {
      const cart = await (await fetch(FF.routes.cart + '.js', { headers: { Accept: 'application/json' } })).json();
      let hasCostume = false;
      if (cart.items.length) {
        const domItems = $$('.cart-item[data-meta]');
        const known = domItems.map((it) => isCostumeMeta(metaOf(it))).filter((k) => k !== null);
        if (known.length && domItems.length >= 1 && domItems.length >= cart.items.length) {
          hasCostume = known.includes(true);
        } else {
          const idx = await ffIndex(routes_all());
          hasCostume = cart.items.some((it) => { const p = idx.find((x) => x.id === it.product_id); return p && valuesOf(p, 'producttype').some(isCostumeType); });
        }
      }
      const list = Array.isArray(cart.discount_codes) ? cart.discount_codes.map((d) => d.code) : null;
      const isMine = (c) => String(c).toLowerCase() === code.toLowerCase();
      const has = list ? list.some(isMine) : false;
      let next = null;
      if (hasCostume && !has) next = [...(list || []), code];
      else if (!hasCostume && has) next = list.filter((c) => !isMine(c));
      if (next === null) return;
      const res = await fetch(FF.routes.cartUpdate + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: next.join(','), sections: cartSectionIds().join(','), sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (res.ok) renderCartSections(data.sections);
    } catch (e) { /* Rabatt-Sync ist optional */ } finally {
      comboSyncing = false;
    }
  }
  FF.syncComboCode = syncComboCode;

  // Hinweis auf der Produktseite unter dem Preis
  async function initComboHint(root = document) {
    if (!combo()) return;
    const el = $('[data-combo-hint]', root);
    if (!el || el._init) return;
    el._init = true;
    const elMeta = metaOf(el);
    const costume = isCostumeMeta(elMeta);
    if (costume === null) return;
    if (!costume && asList(elMeta.producttype).some(isExcludedType)) return; // z. B. Deko: kein Kombi-Rabatt
    const c = combo();
    if (costume) {
      el.classList.add('is-costume');
      el.innerHTML = `${ICON_GIFT}<div><strong>${esc(c.title)}: ${comboAmt()} auf jedes Zubehör</strong><span>Mit diesem Kostüm wird jede Perücke, jeder Hut, jede Maske … ${comboAmt()} günstiger.</span> <a href="#outfit">Passendes Zubehör ansehen</a></div>`;
    } else {
      const has = await cartHasCostume();
      el.classList.toggle('is-active', has);
      if (has) { FF._comboPrice = () => decorateComboPrice(); decorateComboPrice(); } else if (FF._comboPrice) { FF._comboPrice = null; undoComboPrice(); }
      el.innerHTML = has
        ? `${ICON_GIFT}<div><strong>${esc(c.title)} aktiv: Du sparst ${comboAmt()} auf dieses Teil</strong><span>Du hast schon ein Kostüm im Warenkorb, der Rabatt wird automatisch abgezogen.</span></div>`
        : `${ICON_GIFT}<div><strong>${comboAmt()} sparen mit Kostüm</strong><span>Kauf ein Kostüm dazu und dieses Zubehör wird ${comboAmt()} günstiger.</span>${$('#outfit') ? ' <a href="#outfit">Passendes Kostüm ansehen</a>' : ''}</div>`;
    }
    el.hidden = false;
  }

  // Streichpreis oben am Preis, wenn der Kombi-Bonus für dieses Zubehör schon greift
  function decorateComboPrice() {
    const wrap = $('[data-product] [data-price-wrap]');
    const priceEl = wrap && $('[data-price]', wrap);
    if (!priceEl || !combo()) return;
    const cents = parseInt(wrap.dataset.cents, 10);
    if (!cents) return;
    const now = comboPrice(cents);
    if (priceEl.dataset.combo === String(cents)) return;
    priceEl.dataset.combo = String(cents);
    priceEl.dataset.orig = priceEl.innerHTML;
    $$('.price__compare, .price__save', priceEl).forEach((n) => n.remove());
    $('.price__current', priceEl).textContent = formatMoney(now);
    $('.price__current', priceEl).insertAdjacentHTML('afterend', `<s class="price__compare"><span class="visually-hidden">Statt</span>${formatMoney(cents)}</s><span class="combo-tag">-${comboAmt()} ${esc(combo().title)}</span>`);
    priceEl.classList.add('price--sale', 'price--combo');
    // Grundpreis passend zum reduzierten Preis umrechnen
    const unit = $('[data-unit-price]', priceEl);
    if (unit) {
      unit.innerHTML = unit.innerHTML.replace(/(\d{1,3}(?:\.\d{3})*,\d{2})/, (m) => {
        const val = Math.round(parseFloat(m.replace(/\./g, '').replace(',', '.')) * 100 * now / cents);
        return formatMoney(val).replace(/[^\d.,]/g, '').trim();
      });
    }
    const sp = $('[data-sticky-price]');
    if (sp) sp.innerHTML = `${formatMoney(now)} <s>${formatMoney(cents)}</s>`;
  }
  function undoComboPrice() {
    const priceEl = $('[data-product] [data-price-wrap] [data-price]');
    if (priceEl && priceEl.dataset.orig) { priceEl.innerHTML = priceEl.dataset.orig; delete priceEl.dataset.combo; priceEl.classList.remove('price--combo'); }
  }

  // Hinweis im Warenkorb
  function initComboCart(root = document) {
    if (!combo()) return;
    $$('[data-combo-note]', root).forEach((note) => {
      const container = note.closest('[data-cart-body]') || note.parentElement || document;
      const items = $$('.cart-item', container);
      let costumes = 0; let acc = 0; let unknown = 0;
      items.forEach((it) => {
        const q = parseInt(($('[data-qty-input]', it) || {}).value, 10) || 1;
        const k = isCostumeMeta(metaOf(it));
        if (k === true) costumes += q; else if (k === false) acc += q; else unknown++;
      });
      const c = combo();
      let html = '';
      note.className = 'combo-note';
      if (costumes && acc) {
        note.classList.add('is-active');
        html = `${ICON_GIFT}<div><strong>${esc(c.title)} aktiv!</strong><span>Du sparst ${comboAmt()} auf ${acc === 1 ? 'dein Zubehör' : `jedes deiner ${acc} Zubehör-Teile`}. Der Rabatt ist schon abgezogen.</span></div>`;
      } else if (costumes) {
        note.classList.add('is-unlocked');
        html = `${ICON_GIFT}<div><strong>${esc(c.title)} freigeschaltet!</strong><span>Jedes Zubehör ist jetzt ${comboAmt()} günstiger. Schnurrbart, Perücke oder Hut dazu?</span></div>`;
      } else if (acc) {
        html = `${ICON_GIFT}<div><strong>${comboAmt()} pro Zubehör sparen</strong><span>Leg ein Kostüm dazu und dein Zubehör wird automatisch ${comboAmt()} günstiger.</span></div>`;
      }
      note.innerHTML = html;
      note.hidden = !html;
      note.dataset.costumeInCart = costumes ? '1' : '';
    });
  }

  // Mehrere Artikel hinzufügen, ohne dass ein einzelner Fehler (z. B. Lagerbestand erreicht) alles blockiert.
  // Bereits im Warenkorb liegende Varianten werden übersprungen, damit keine Höchstmengen überschritten werden.
  async function addItemsSafely(items, sourceEl) {
    let inCart = [];
    try { inCart = (await (await fetch(FF.routes.cart + '.js')).json()).items.map((i) => i.variant_id); } catch (e) { /* egal */ }
    const todo = items.filter((it) => !inCart.includes(it.id));
    const skipped = items.length - todo.length;
    const added = []; const failed = [];
    if (todo.length) {
      try {
        await addToCart(todo, sourceEl);
        added.push(...todo);
      } catch (e) {
        for (const it of todo) {
          try {
            const r = await fetch(FF.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [it] }) });
            const d = await r.json();
            if (!r.ok || d.status) failed.push(it); else added.push(it);
          } catch (err) { failed.push(it); }
        }
        if (added.length) {
          try {
            const u = new URL(window.location.pathname, window.location.origin);
            u.searchParams.set('sections', cartSectionIds().join(','));
            renderCartSections(await (await fetch(u.toString())).json());
            const cart = await (await fetch(FF.routes.cart + '.js')).json();
            updateCount(cart.item_count);
            if (FF.cartType === 'drawer' && $('[data-cart-drawer]')) openDrawer('CartDrawer');
          } catch (err) { /* egal */ }
        }
      }
    }
    if (failed.length) toast(added.length ? `${added.length} hinzugefügt. ${failed.length === 1 ? 'Ein Artikel ist' : failed.length + ' Artikel sind'} leider nicht mehr in dieser Menge verfügbar.` : 'Leider ist dieser Artikel nicht mehr in dieser Menge verfügbar.');
    else if (!todo.length && skipped) toast(skipped === 1 ? 'Liegt schon in deinem Warenkorb.' : 'Liegt alles schon in deinem Warenkorb.');
    return { added, failed, skipped };
  }

  const mainCostumeId = () => {
    const inp = $('[data-product] [data-product-form] input[name="id"]');
    return inp && inp.value ? parseInt(inp.value, 10) : null;
  };

  /* ---------- Outfit-Baukasten (Kostüm -> Zubehör nach Produkttyp) -- */
  function buildOutfit(box, el, scored, self, why, opts = {}) {
    const order = String(box.dataset.typeOrder || '').split(/\s*[,;\n]\s*/).map(norm).filter(Boolean);
    const max = parseInt(box.dataset.typeMax, 10) || 6;
    const builder = box.dataset.outfitMode !== 'tabs';
    const typeLabel = (p) => valuesOf(p, 'producttype').find((t) => !isCostumeType(t)) || 'Zubehör';
    // nach Produkttyp gruppieren
    const groups = new Map();
    scored.forEach(({ p, tier }) => {
      const label = typeLabel(p);
      const k = norm(label);
      if (!groups.has(k)) groups.set(k, { key: k, label, items: [] });
      groups.get(k).items.push({ p, tier });
    });
    const rank = (k) => {
      const i = order.findIndex((o) => k === o || k.startsWith(o) || o.startsWith(k));
      return i === -1 ? 999 : i;
    };
    const list = [...groups.values()]
      .map((g) => { g.items.sort((a, b) => a.tier - b.tier); g.rank = rank(g.key); g.stage = Math.ceil(g.items[0].tier / 20); return g; })
      // erst die Arten mit genau passenden Treffern, dann die gelockerten; innerhalb nach deiner Reihenfolge
      .sort((a, b) => (opts.manual ? a.items[0].tier - b.items[0].tier : (a.stage - b.stage || a.rank - b.rank || b.items.length - a.items.length || a.label.localeCompare(b.label, 'de'))))
      .slice(0, opts.manual ? 12 : max);
    if (!list.length) return false;

    const head = $('[data-upsell-heading]', box);
    if (head && box.dataset.headingOutfit) head.innerHTML = box.dataset.headingOutfit;
    const reason = $('[data-upsell-reason]', box);
    if (reason && opts.manual) reason.textContent = 'Von uns passend zu diesem Kostüm zusammengestellt';
    else if (reason && why) reason.textContent = `${list.length} Zubehör-Arten passend zu „${why[0]}“${why[1] ? ` für ${why[1]}` : ''}`;
    $('[data-upsell-list]', box).innerHTML = '';
    const tabs = $('[data-outfit-tabs]', el);
    const row = $('[data-outfit-row]', el);
    const bar = $('[data-outfit-bar]', el);
    el.classList.toggle('outfit--builder', builder);
    const cb = $('[data-outfit-combo]', el);
    if (cb && combo()) {
      cb.innerHTML = `${ICON_GIFT}<div><strong>${esc(combo().title)}: ${comboAmt()} Rabatt auf jedes Zubehör</strong><span>Gilt automatisch, sobald dieses Kostüm mit im Warenkorb liegt.</span></div>`;
      cb.hidden = false;
    }
    el.classList.toggle('outfit--tabs', !builder);

    const variantSelect = (p, gi, chosen) => {
      const vs = p.vs || [];
      if (vs.length <= 1) return '';
      const optName = esc((((p.o || [])[0] || {}).n || 'Größe').replace(/^./, (c) => c.toUpperCase()));
      return `<label class="visually-hidden" for="OF-${gi}-${p.id}">${optName} für ${esc(p.t)}</label>
        <select class="outfit__variant${chosen ? '' : ' is-empty'}" id="OF-${gi}-${p.id}" data-outfit-variant>
          <option value=""${chosen ? '' : ' selected'} disabled>${optName} wählen</option>
          ${vs.map((v) => `<option value="${v[1]}"${v[2] ? '' : ' disabled'}${String(chosen) === String(v[1]) ? ' selected' : ''}>${esc(v[0])}${v[2] ? '' : ' (ausverkauft)'}</option>`).join('')}
        </select>`;
    };
    const slotInner = (g, gi) => {
      const p = g.items[g.idx].p;
      const total = g.items.length;
      const canAdd = (p.vs || []).length > 0;
      return `
        <div class="outfit__top">
          <span class="outfit__type">${esc(g.label)}</span>
          ${total > 1 ? `<span class="outfit__nav">
            <button type="button" class="outfit__arrow" data-outfit-step="-1" aria-label="Vorherige Auswahl ${esc(g.label)}">${ICON_CHEV_L}</button>
            <span class="outfit__pos">${g.idx + 1}/${total}</span>
            <button type="button" class="outfit__arrow" data-outfit-step="1" aria-label="Nächste Auswahl ${esc(g.label)}">${ICON_CHEV_R}</button>
          </span>` : ''}
        </div>
        <a class="outfit__media" href="${esc(p.u)}">${p.i ? `<img src="${esc(p.i)}" alt="${esc(p.t)}" loading="lazy" width="300" height="400">` : ''}</a>
        <p class="outfit__title"><a href="${esc(p.u)}">${esc(p.t)}</a></p>
        <div class="price${p.c && p.c > p.p ? ' price--sale' : ''}"><span class="price__current">${formatMoney(p.p)}</span>${p.c && p.c > p.p ? `<s class="price__compare">${formatMoney(p.c)}</s>` : ''}${p.up ? `<span class="price__unit">Grundpreis: ${esc(p.up)}</span>` : ''}</div>
        ${combo() ? `<p class="outfit__combo">${ICON_GIFT}<span>mit Kostüm <strong>${comboPrice(p.p) === 0 ? 'gratis' : formatMoney(comboPrice(p.p))}</strong></span></p>` : ''}
        ${variantSelect(p, gi, g.vid && g.vid[p.id])}
        ${canAdd ? `<label class="outfit__check"><input type="checkbox" data-outfit-pick${g.on ? ' checked' : ''}><span>${g.on ? 'Ausgewählt' : 'Auswählen'}</span></label>`
          : `<a class="btn btn--sm" href="${esc(p.u)}">Optionen wählen</a>`}`;
    };
    const renderSlot = (gi) => {
      const g = list[gi];
      const slot = $(`[data-outfit-slot="${gi}"]`, row);
      if (!slot) return;
      slot.innerHTML = slotInner(g, gi);
      slot.classList.toggle('is-on', !!g.on);
    };
    const chosenVariant = (g) => {
      const p = g.items[g.idx].p;
      const vs = p.vs || [];
      if (vs.length === 1) return vs[0][2] ? vs[0][1] : null;
      return (g.vid && g.vid[p.id]) || null;
    };
    el._chosenVariant = chosenVariant;
    const updateBar = () => {
      const chosen = list.filter((g) => g.on && (g.items[g.idx].p.vs || []).length);
      const sum = chosen.reduce((a, g) => a + g.items[g.idx].p.p, 0);
      $('[data-outfit-count]', bar).textContent = chosen.length === 1 ? '1 Teil' : `${chosen.length} Teile`;
      const tot = $('[data-outfit-total]', bar);
      if (combo() && chosen.length) {
        const after = chosen.reduce((a, g) => a + comboPrice(g.items[g.idx].p.p), 0);
        tot.innerHTML = `<s><span class="visually-hidden">Statt</span>${formatMoney(sum)}</s> ${formatMoney(after)} <em>mit Kostüm, du sparst ${formatMoney(sum - after)}</em>`;
      } else {
        tot.textContent = chosen.length ? formatMoney(sum) : '';
      }
      const addBtn = $('[data-outfit-add]', bar);
      addBtn.disabled = !chosen.length;
      const mainId = mainCostumeId();
      addBtn.textContent = !chosen.length ? 'Teile auswählen' : (mainId && !el._costumeInCart ? `Kostüm + ${chosen.length === 1 ? '1 Teil' : `${chosen.length} Teile`} in den Warenkorb` : `${chosen.length === 1 ? '1 Teil' : `${chosen.length} Teile`} in den Warenkorb`);
      bar.hidden = !builder;
    };

    // Reiter (bei "tabs" Pflicht, beim Baukasten als Sprungmarken)
    let active = 0;
    tabs.setAttribute('role', builder ? 'group' : 'tablist');
    tabs.innerHTML = list.map((g, gi) => `<button type="button"${builder ? '' : ' role="tab"'} class="outfit__tab${!builder && gi === 0 ? ' is-active' : ''}"${builder ? '' : ` aria-selected="${gi === 0}"`} data-outfit-tab="${gi}">${esc(g.label)} <span>${g.items.length}</span></button>`).join('');
    tabs.hidden = builder && list.length < 3;

    if (builder) {
      list.forEach((g) => { g.idx = 0; g.on = false; g.vid = {}; });
      row.innerHTML = (self ? `<div class="outfit__slot outfit__slot--self">
          <div class="outfit__top"><span class="outfit__type">Dein Kostüm</span></div>
          <div class="outfit__media">${self.i ? `<img src="${esc(self.i)}" alt="${esc(self.t)}" loading="lazy" width="300" height="400">` : ''}</div>
          <p class="outfit__title">${esc(self.t)}</p>
        </div>` : '') + list.map((g, gi) => `<div class="outfit__slot" data-outfit-slot="${gi}"></div>`).join('');
      list.forEach((g, gi) => renderSlot(gi));
    } else {
      const showTab = (gi) => {
        active = gi;
        $$('[data-outfit-tab]', tabs).forEach((b, i) => { b.classList.toggle('is-active', i === gi); b.setAttribute('aria-selected', String(i === gi)); });
        row.innerHTML = `<div class="grid" style="--cols:4;--cols-t:3">${list[gi].items.slice(0, 8).map((x) => renderCardHTML(x.p)).join('')}</div>`;
      };
      el._showTab = showTab;
      showTab(0);
    }
    updateBar();

    if (!el._bound) {
      el._bound = true;
      on(el, 'click', async (e) => {
        const tab = e.target.closest('[data-outfit-tab]');
        if (tab) {
          const gi = parseInt(tab.dataset.outfitTab, 10);
          if (el._showTab) { el._showTab(gi); return; }
          const slot = $(`[data-outfit-slot="${gi}"]`, row);
          if (slot) { slot.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'nearest', inline: 'center' }); slot.classList.add('is-flash'); setTimeout(() => slot.classList.remove('is-flash'), 900); }
          return;
        }
        const step = e.target.closest('[data-outfit-step]');
        if (step) {
          const gi = parseInt(step.closest('[data-outfit-slot]').dataset.outfitSlot, 10);
          const g = el._list[gi];
          g.idx = (g.idx + parseInt(step.dataset.outfitStep, 10) + g.items.length) % g.items.length;
          if (!(g.items[g.idx].p.vs || []).length) g.on = false;
          el._renderSlot(gi); el._updateBar();
          return;
        }
        const add = e.target.closest('[data-outfit-add]');
        if (add) {
          const items = [];
          let missing = null;
          el._list.forEach((g, gi) => {
            if (!g.on) return;
            const id = el._chosenVariant(g);
            if (id) items.push({ id: parseInt(id, 10), quantity: 1 });
            else if (!missing) missing = gi;
          });
          if (missing !== null) {
            const sel = $(`[data-outfit-slot="${missing}"] [data-outfit-variant]`, el);
            toast(`Bitte wähle noch eine Größe für ${el._list[missing].label}.`);
            if (sel) { sel.focus(); sel.classList.add('is-error'); setTimeout(() => sel.classList.remove('is-error'), 1600); }
            return;
          }
          if (!items.length) return;
          // Kombi-Rabatt greift nur mit Kostüm im Warenkorb: Kostüm mitnehmen, wenn eine Größe gewählt ist
          if (!el._costumeInCart) {
            const cid = mainCostumeId();
            if (cid) {
              const qty = parseInt(($('[data-product] input[name="quantity"]') || {}).value, 10) || 1;
              items.unshift({ id: cid, quantity: qty });
            } else if (combo()) {
              const picker = $('[data-product] [data-option-index]');
              toast('Bitte wähle zuerst die Größe deines Kostüms, dann kommt alles zusammen in den Warenkorb.');
              picker && picker.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'center' });
              return;
            }
          }
          add.classList.add('is-loading');
          try {
            const res = await addItemsSafely(items, add);
            if (res.added.length) { el._costumeInCart = el._costumeInCart || !!mainCostumeId(); el._updateBar(); }
          } finally { add.classList.remove('is-loading'); }
        }
      });
      on(el, 'change', (e) => {
        const vsel = e.target.closest('[data-outfit-variant]');
        if (vsel) {
          const slotEl = vsel.closest('[data-outfit-slot]');
          const gi = parseInt(slotEl.dataset.outfitSlot, 10);
          const g = el._list[gi];
          g.vid = g.vid || {};
          g.vid[g.items[g.idx].p.id] = vsel.value;
          vsel.classList.toggle('is-empty', !vsel.value);
          const box = $('[data-outfit-pick]', slotEl);
          if (vsel.value && box && !box.checked) { box.checked = true; box.dispatchEvent(new Event('change', { bubbles: true })); }
          el._updateBar();
          return;
        }
        const pick = e.target.closest('[data-outfit-pick]');
        if (!pick) return;
        const gi = parseInt(pick.closest('[data-outfit-slot]').dataset.outfitSlot, 10);
        el._list[gi].on = pick.checked;
        const slot = pick.closest('[data-outfit-slot]');
        slot.classList.toggle('is-on', pick.checked);
        const t = pick.nextElementSibling; if (t) t.textContent = pick.checked ? 'Ausgewählt' : 'Auswählen';
        el._updateBar();
      });
    }
    el._list = list; el._renderSlot = renderSlot; el._updateBar = updateBar;
    cartHasCostume().then((has) => { el._costumeInCart = has; updateBar(); });
    if (!el._formBound) {
      el._formBound = true;
      const form = $('[data-product] [data-product-form]');
      form && on(form.closest('[data-product]'), 'change', () => setTimeout(() => el._updateBar && el._updateBar(), 0));
    }
    el.hidden = false;
    box.hidden = false;
    return true;
  }

  function metaOf(el) {
    let m = {};
    try { m = JSON.parse(el.getAttribute('data-meta') || '{}'); } catch (e) { m = {}; }
    if (el.getAttribute('data-product-id')) m._id = String(el.getAttribute('data-product-id'));
    if (el.getAttribute('data-title')) m._title = el.getAttribute('data-title');
    return m;
  }
  function initUpsell(root = document) {
    // Produktseite
    $$('section[data-upsell]', root).forEach((box) => {
      if (box._init) return;
      box._init = true;
      // Sektion ist bis zum Ergebnis versteckt, daher kurz nach dem Laden starten
      const run = () => fillUpsell(box, metaOf(box), [String(box.dataset.productId)]);
      ('requestIdleCallback' in window) ? requestIdleCallback(run, { timeout: 1500 }) : setTimeout(run, 600);
    });
    // Warenkorb: nach dem zuletzt hinzugefügten Artikel
    $$('.cart-upsell[data-upsell]', root).forEach((box) => {
      if (box._init) return;
      box._init = true;
      const container = box.closest('[data-cart-body]') || document;
      const items = $$('.cart-item', container);
      if (!items.length) return;
      const exclude = items.map((i) => String(i.dataset.productId));
      (async () => {
        for (const item of items) { // neuester Artikel steht oben
          if (await fillUpsell(box, metaOf(item), exclude)) return;
        }
      })();
    });
  }

  /* ---------- Empfehlungen -------------------------------------------- */
  function initRecommendations(root = document) {
    $$('[data-recommendations]', root).forEach((el) => {
      if (el._init) return;
      el._init = true;
      const load = async () => {
        try {
          const html = await (await fetch(el.dataset.url)).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initReveal(el); }
        } catch (e) { /* keine Empfehlungen */ }
      };
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(([en]) => { if (en.isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px' });
        io.observe(el);
      } else load();
    });
  }

  /* ---------- Init & Theme-Editor ------------------------------------ */
  function initAll(root = document) {
    initReveal(root);
    [initRecommendations, initAnnouncement, initProduct, initDelivery, initCountdown, initHero, initFacets, initFinder, initUpsell, initComboHint, initComboCart].forEach((fn) => {
      try { fn(root); } catch (err) { console.error('[FreakyFits]', fn.name, err); }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    initPredictive();
    fillEmptyText();
    initAll();
    initFinderResults();
    initSkuFallback();
    syncComboCode();
    window.addEventListener('hashchange', () => { if (location.hash.startsWith('#ff=')) location.reload(); });
  });

  document.addEventListener('shopify:section:load', (e) => {
    initAll(e.target);
    if (e.target.querySelector('[data-header]')) { initHeader(); initPredictive(); }
  });
  document.addEventListener('shopify:block:select', (e) => {
    const slide = e.target.closest('.hero__slide');
    if (slide) {
      const hero = slide.closest('[data-hero]');
      $$('.hero__slide', hero).forEach((s) => s.classList.toggle('is-active', s === slide));
    }
  });
})();
